/* ============================================================================
   wynlc.js  ->  Edit code > Assets > wynlc.js
   Label Converter. Every customer-visible word comes from the section's boot
   JSON, so a copy change is a section edit and never a change to this file.
   If this text is showing on your page, it went into a Liquid box by mistake.
   ========================================================================= */
(function () {
  "use strict";

  var ROOT = document.getElementById('wynlc');
  if (!ROOT) return;
  var BOOTEL = document.getElementById('wynlc-boot');
  if (!BOOTEL) return;

  var BOOT = {};
  try { BOOT = JSON.parse(BOOTEL.textContent || '{}'); } catch (e) { BOOT = {}; }
  var C = BOOT.copy || {};
  function t(k, fallback) {
    var v = C[k];
    return (v === undefined || v === null || v === '') ? (fallback || '') : v;
  }

  /* ---------------------------------------------------------------------- */
  /* reference data                                                          */
  /* ---------------------------------------------------------------------- */
  /* AAFCO 2014 Dog Food Nutrient Profiles expressed per 1000 kcal ME.
     VERIFIED 2026-08-22 against AAFCO's published dry-matter table: adult
     protein 18.0% and fat 5.5%, growth 22.5% and 8.5%, x2.5 for the 4000
     kcal/kg DM basis the profiles assume. Growth sodium was 0.8 here and the
     table gives 0.3% DM, so 0.75. Each
     figure is the published dry-matter percentage multiplied by 2.5, which is
     the conversion AAFCO documents for a 4000 kcal/kg DM basis. */
  var AAFCO = {
    protein:    { adult: { min: 45 },              growth: { min: 56.3 } },
    fat:        { adult: { min: 13.8 },            growth: { min: 21.3 } },
    linoleic:   { adult: { min: 2.8 },             growth: { min: 3.3 } },
    calcium:    { adult: { min: 1.25, max: 6.25 }, growth: { min: 3.0, max: 4.5 } },
    phosphorus: { adult: { min: 1.0,  max: 4.0 },  growth: { min: 2.5, max: 4.0 } },
    potassium:  { adult: { min: 1.5 },             growth: { min: 1.5 } },
    sodium:     { adult: { min: 0.2 },             growth: { min: 0.75 } },
    chloride:   { adult: { min: 0.3 },             growth: { min: 1.1 } },
    magnesium:  { adult: { min: 0.15 },            growth: { min: 0.15 } }
  };

  /* bound: what a guaranteed-analysis figure means. 'min' = the label promises
     at least this much, 'max' = at most. out: the unit of the converted value.
     alt: the key spellings accepted when reading a Wynwood diet record. */
  var LIB = [
    { key: 'protein',    bound: 'min', unit: '%',     out: 'g',  core: 1,
      alt: ['protein', 'crude_protein', 'cp'] },
    { key: 'fat',        bound: 'min', unit: '%',     out: 'g',  core: 1,
      alt: ['fat', 'crude_fat', 'cf', 'ee'] },
    { key: 'fiber',      bound: 'max', unit: '%',     out: 'g',  core: 1,
      alt: ['fiber', 'crude_fiber', 'fiber', 'crude_fiber'] },
    { key: 'moisture',   bound: 'max', unit: '%',     out: '-',  core: 1,
      alt: ['moisture', 'water'] },
    /* Some panels guarantee a Total Carbohydrate maximum outright. Its own key,
       because `carb` is already the DERIVED range and the two must not collide. */
    { key: 'tcarb',      bound: 'max', unit: '%',     out: 'g',
      alt: ['total_carbohydrate', 'totalcarbohydrate', 'carbohydrate', 'carbohydrates',
            'total_carbohydrates', 'carbs', 'nfe'] },
    { key: 'ash',        bound: 'max', unit: '%',     out: 'g',
      alt: ['ash', 'crude_ash'] },
    { key: 'calcium',    bound: 'min', unit: '%',     out: 'g',
      alt: ['calcium', 'ca'] },
    { key: 'phosphorus', bound: 'min', unit: '%',     out: 'g',
      alt: ['phosphorus', 'phosphorous', 'p'] },
    { key: 'sodium',     bound: 'min', unit: '%',     out: 'g',
      alt: ['sodium', 'na'] },
    { key: 'potassium',  bound: 'min', unit: '%',     out: 'g',
      alt: ['potassium', 'k'] },
    { key: 'magnesium',  bound: 'max', unit: '%',     out: 'g',
      alt: ['magnesium', 'mg'] },
    { key: 'chloride',   bound: 'min', unit: '%',     out: 'g',
      alt: ['chloride', 'cl'] },
    { key: 'linoleic',   bound: 'min', unit: '%',     out: 'g',
      alt: ['linoleic', 'linoleic_acid', 'la'] },
    { key: 'omega3',     bound: 'min', unit: '%',     out: 'g',
      alt: ['omega3', 'omega_3', 'total_omega_3'] },
    { key: 'epadha',     bound: 'min', unit: '%',     out: 'g',
      alt: ['epadha', 'epa_dha', 'epa_plus_dha'] },
    { key: 'taurine',    bound: 'min', unit: '%',     out: 'mg',
      alt: ['taurine'] },
    { key: 'carnitine',  bound: 'min', unit: 'mg/kg', out: 'mg',
      alt: ['carnitine', 'l_carnitine'] },
    { key: 'glucos',     bound: 'min', unit: 'mg/kg', out: 'mg',
      alt: ['glucosamine'] },
    { key: 'chondro',    bound: 'min', unit: 'mg/kg', out: 'mg',
      alt: ['chondroitin'] }
  ];
  var BYKEY = {};
  LIB.forEach(function (n) { BYKEY[n.key] = n; });

  function nlabel(key) { return t('n_' + key, key); }


  /* ---------------------------------------------------------------------- */
  /* state                                                                   */
  /* ---------------------------------------------------------------------- */
  var fromPhoto = {};
  var state = {
    basis: 'ga',
    ranges: null,
    rangesErr: '',
    rows: [{ key: 'protein', v: '' }, { key: 'fat', v: '' },
           { key: 'fiber', v: '' }, { key: 'moisture', v: '' }],
    diets: null,
    dietsErrDetail: '',
    rangeTried: [],
    dietsMeta: null,
    dietSample: null,
    dietsErr: '',
    dietsTried: [],
    pick: ''
  };

  function $(id) { return document.getElementById(id); }

  /* The theme has a fixed header, so a plain scroll parks the target
     underneath it and you land two rows into a table with its heading hidden.
     Guessing at class names missed it, so this asks the browser what is
     actually pinned across the top of the viewport and clears that. */
  function stickyOffset() {
    var most = 0;
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    var xs = [Math.round(w * 0.5), 8, Math.max(8, w - 8)];
    for (var i = 0; i < xs.length; i++) {
      var els = document.elementsFromPoint ? document.elementsFromPoint(xs[i], 2) : [];
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (!el || !el.getBoundingClientRect) continue;
        if (el.closest && el.closest('#wynlc')) continue;
        if (el === document.body || el === document.documentElement) continue;
        var pos = window.getComputedStyle(el).position;
        if (pos !== 'fixed' && pos !== 'sticky') continue;
        var r = el.getBoundingClientRect();
        if (r.height < 8 || r.height > 300) continue;
        if (r.bottom > most) most = r.bottom;
      }
    }
    return Math.round(most) + 12;
  }

  function scrollToEl(el) {
    if (!el) return;
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || 0) - stickyOffset();
    if (window.scrollTo) {
      try { window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' }); return; }
      catch (e) { window.scrollTo(0, Math.max(0, y)); return; }
    }
    if (el.scrollIntoView) el.scrollIntoView();
  }
  function num(x) { var n = parseFloat(x); return isFinite(n) ? n : null; }
  function esc(s) {
    return String(s === undefined || s === null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------------------------------------------------------------------- */
  /* energy                                                                  */
  /* ---------------------------------------------------------------------- */
  var G_PER = { g: 1, oz: 28.3495, lb: 453.592 };

  function kcalPerKg() {
    var c = num($('wynlc-ecal').value);
    if (c === null || c <= 0) return null;
    var u = $('wynlc-eunit').value;
    if (u === 'kg') return c;
    if (u === '100g') return c * 10;
    if (u === 'oz') return c / 28.3495 * 1000;
    var w = num($('wynlc-ewt').value);
    if (w === null || w <= 0) return null;
    var grams = w * G_PER[$('wynlc-ewtu').value];
    if (grams <= 0) return null;
    return c / grams * 1000;
  }
  function needsWeight() {
    var u = $('wynlc-eunit').value;
    return u === 'cup' || u === 'can' || u === 'pkg';
  }

  /* ---------------------------------------------------------------------- */
  /* the conversion                                                          */
  /* ---------------------------------------------------------------------- */
  /* percent as fed -> grams per 1000 kcal. One kilogram of food holds ten
     times the percentage in grams and E kilocalories, so the grams per
     1000 kcal are 10 x percent / E x 1000. */
  function perThousand(pct, E) { return pct * 10000 / E; }
  function perThousandMg(mgkg, E) { return mgkg * 1000 / E; }
  function dryMatter(pct, moisture) {
    if (moisture === null) return null;
    var dm = 100 - moisture;
    if (dm <= 0) return null;
    return pct * 100 / dm;
  }

  function fig(x) {
    if (x === null || !isFinite(x)) return '';
    var a = Math.abs(x);
    if (a >= 100) return x.toFixed(0);
    return a >= 1 ? x.toFixed(1) : x.toFixed(2);
  }

  /* Whole numbers read better for the big figures, but a blanket rule would
     turn 0.63 g of phosphorus into 1 and 2.8 g of fiber into 3, which are the
     two places the decimal carries the meaning. So: whole at 10 and above,
     one decimal below that, two below 1, and fiber always keeps a decimal
     because it is the row most often compared closely. */
  function figFor(key, x) {
    if (x === null || x === undefined || !isFinite(x)) return '';
    var a = Math.abs(x);
    if (key === 'fiber') return a >= 1 ? x.toFixed(1) : x.toFixed(2);
    if (a >= 10) return x.toFixed(0);
    return a >= 1 ? x.toFixed(1) : x.toFixed(2);
  }

  /* ---------------------------------------------------------------------- */
  /* rows                                                                    */
  /* ---------------------------------------------------------------------- */
  function drawRows() {
    var host = $('wynlc-rows');
    host.innerHTML = '';
    state.rows.forEach(function (r, i) {
      var def = BYKEY[r.key];
      var id = 'wynlc-in-' + r.key;
      var word = def.bound === 'min' ? t('w_min', 'minimum') : t('w_max', 'maximum');
      var note = t('note_' + r.key, '');
      var tag = fromPhoto[r.key] ? t('ph_tag', 'from your photo') : '';
      var d = document.createElement('div');
      d.className = 'lc-arow' + (fromPhoto[r.key] ? ' lc-marked' : '');
      d.innerHTML =
        '<div class="lc-nm"' + (tag ? ' data-tag="' + esc(tag) + '"' : '') +
          '><label for="' + id + '">' + esc(nlabel(r.key)) + '</label>' +
          '<em>' + esc(word) + (note ? ' &middot; ' + esc(note) : '') + '</em></div>' +
        '<div><input id="' + id + '" type="number" inputmode="decimal" step="any" value="' +
          esc(r.v) + '"></div>' +
        '<div><input class="lc-unit" value="' + esc(def.unit) + '" disabled aria-label="' +
          esc(t('a_unit', 'Unit')) + '"></div>' +
        '<button type="button" class="lc-kill" aria-label="' +
          esc(t('a_remove', 'Remove') + ' ' + nlabel(r.key)) + '">&times;</button>';
      d.querySelector('input').addEventListener('input', function (e) {
        state.rows[i].v = e.target.value;
        render();
      });
      d.querySelector('.lc-kill').addEventListener('click', function () {
        state.rows.splice(i, 1);
        drawRows(); drawAdd(); render();
      });
      host.appendChild(d);
    });
  }

  function drawAdd() {
    var sel = $('wynlc-addsel');
    sel.innerHTML = '';
    var used = {};
    state.rows.forEach(function (r) { used[r.key] = 1; });
    var any = false;
    LIB.forEach(function (n) {
      if (used[n.key]) return;
      any = true;
      var o = document.createElement('option');
      o.value = n.key;
      o.textContent = nlabel(n.key);
      sel.appendChild(o);
    });
    sel.disabled = !any;
    $('wynlc-addbtn').disabled = !any;
    if (!any) {
      var o = document.createElement('option');
      o.textContent = t('all_added', 'All nutrients added');
      sel.appendChild(o);
    }
  }

  /* ---------------------------------------------------------------------- */
  /* compute                                                                 */
  /* ---------------------------------------------------------------------- */
  function moistureVal() {
    var m = null;
    state.rows.forEach(function (r) { if (r.key === 'moisture') m = num(r.v); });
    return m;
  }

  function computed() {
    var E = kcalPerKg();
    if (E === null) return null;
    var moist = moistureVal();
    var out = [];
    state.rows.forEach(function (r) {
      var def = BYKEY[r.key], v = num(r.v);
      if (v === null) return;
      var o = { key: r.key, def: def, asfed: v };
      if (def.unit === 'mg/kg') {
        o.per1000 = perThousandMg(v, E); o.dm = null; o.outUnit = 'mg';
      } else if (def.out === '-') {
        o.per1000 = null; o.dm = null; o.outUnit = null;
      } else if (def.out === 'mg') {
        o.per1000 = perThousand(v, E) * 1000; o.dm = dryMatter(v, moist); o.outUnit = 'mg';
      } else {
        o.per1000 = perThousand(v, E); o.dm = dryMatter(v, moist); o.outUnit = 'g';
      }
      out.push(o);
    });
    return { E: E, moisture: moist, rows: out };
  }

  /* ashHint lets the caller pass the middle of the format's own published ash
     band. Without it the printed carbohydrate used a hardcoded 7 percent while
     the adjusted column beside it used the file's band, so the two columns
     disagreed about the same assumption. */
  function carbohydrate(c, ashHint) {
    var have = {};
    c.rows.forEach(function (r) { have[r.key] = r.asfed; });
    if (have.protein == null || have.fat == null || have.fiber == null || c.moisture == null) {
      return null;
    }
    var ash = have.ash, assumed = false;
    if (ash == null) {
      ash = (ashHint !== null && ashHint !== undefined && isFinite(ashHint))
        ? ashHint
        : (c.moisture >= 60 ? 2.5 : 7);
      assumed = true;
    }
    var nfe = 100 - (have.protein + have.fat + have.fiber + c.moisture + ash);
    return {
      pct: nfe, assumedAsh: assumed, ash: ash, impossible: (nfe < 0),
      per1000: perThousand(nfe, c.E), dm: dryMatter(nfe, c.moisture)
    };
  }

  /* ---------------------------------------------------------------------- */
  /* the Wynwood diets                                                       */
  /* ---------------------------------------------------------------------- */
  /* The file is read live from the storefront so no nutrient figure is ever
     copied into this tool. Its exact shape is not assumed: both an array and a
     keyed object are accepted, and every nutrient key is matched against the
     spellings in LIB. If it cannot be read or cannot be understood the panel
     says so in plain words rather than showing an empty picker. */
  function expandMap(obj) {
    var out = [], k;
    for (k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      if (k.charAt(0) === '_') continue;
      var v = obj[k];
      if (v && typeof v === 'object' && !Array.isArray(v)) {
        if (!v.handle && !v.key && !v.name) {
          v = Object.assign({}, v, { handle: k });
        }
        out.push(v);
      }
    }
    return out;
  }

  /* The real file keys its diets BY NAME rather than listing them, so a
     container has to be expanded, not just read. Reading `data.diets` as an
     array and giving up is what made the panel say the file had no nutrients
     when it is full of them. */
  function pickList(data) {
    if (!data) return null;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.diets)) return data.diets;
    if (Array.isArray(data.data)) return data.data;
    if (data.diets && typeof data.diets === 'object') {
      var fromMap = expandMap(data.diets);
      if (fromMap.length) return fromMap;
    }
    var out = expandMap(data);
    return out.length ? out : null;
  }

  function dietName(d) {
    var n = d.title || d.name || d.label || d.handle || d.key || '';
    /* the file writes them lowercase. Only touch a name that has no capitals
       of its own, so an already-cased title is never mangled. */
    if (n && n === n.toLowerCase()) {
      n = n.replace(/(^|[\s+(\/-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
    }
    return n;
  }
  function dietGroup(d) {
    var ty = String(d.type || '').toLowerCase();
    if (ty.indexOf('rx') > -1) return t('cmp_grp_rx', 'Fresh Rx');
    if (ty) return t('cmp_grp_cb', 'Complete and balanced');
    return '';
  }

  function normKey(k) {
    return String(k).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }
  /* Nutrients arrive grouped into basic_components, vitamins, minerals and
     amino_acids, so a flat read of the block finds nothing. Descend through
     nested objects and lift every leaf to the top, which works whether the
     file groups them or not. */
  function lowerMap(obj, depth) {
    var out = {}, k, v;
    depth = depth === undefined ? 2 : depth;
    for (k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      v = obj[k];
      if (v && typeof v === 'object' && !Array.isArray(v) && depth > 0) {
        var inner = lowerMap(v, depth - 1), ik;
        for (ik in inner) {
          if (Object.prototype.hasOwnProperty.call(inner, ik) && out[ik] === undefined) {
            out[ik] = inner[ik];
          }
        }
      } else {
        if (out[normKey(k)] === undefined) out[normKey(k)] = v;
      }
    }
    return out;
  }
  function dietEnergy(d) {
    var e = d.kcal_per_kg || d.kcalPerKg || d.kcal_kg || d.energy_kcal_per_kg;
    var n = parseFloat(e);
    return isFinite(n) && n > 0 ? n : null;
  }

  /* How many shapes a diet file can reasonably take, named rather than
     guessed at by the size of the numbers. Magnitude is not evidence: 9 could
     be a percentage or a gram figure, and being wrong there is worse than
     saying nothing. */
  var P1K_KEYS = ['per_1000kcal', 'per1000kcal', 'per_1000_kcal', 'per_1000',
                  'nutrients_per_1000kcal', 'g_per_1000kcal'];
  var ASFED_KEYS = ['as_fed', 'asfed', 'guaranteed_analysis', 'guaranteed', 'analysis', 'ga',
                    'typical_analysis', 'average_analysis'];

  function fileUnits() {
    var meta = state.dietsMeta;
    if (!meta) return null;
    /* nutrient_units in the real file is a MAP of nutrient to g/mg/IU, not a
       basis. The basis is spelled out in _meta.basis. */
    var u = meta.basis || meta.units || meta.nutrientUnits || meta.nutrient_units;
    if (!u || typeof u === 'object') return null;
    u = String(u).toLowerCase();
    if (u.indexOf('1000') > -1 || u.indexOf('1,000') > -1) return 'per1000';
    if (u.indexOf('as fed') > -1 || u.indexOf('as_fed') > -1 || u.indexOf('percent') > -1 ||
        u.indexOf('%') > -1) return 'asfed';
    return null;
  }

  /* Returns { vals, mode } or null. mode is what the figures ARE, not what we
     want them to be. */
  function dietBlock(d) {
    if (!d || typeof d !== 'object') return null;
    var i, v;
    for (i = 0; i < P1K_KEYS.length; i++) {
      v = d[P1K_KEYS[i]];
      if (v && typeof v === 'object') return { vals: lowerMap(v), mode: 'per1000' };
    }
    for (i = 0; i < ASFED_KEYS.length; i++) {
      v = d[ASFED_KEYS[i]];
      if (v && typeof v === 'object') return { vals: lowerMap(v), mode: 'asfed' };
    }
    var units = fileUnits();
    if (d.nutrients && typeof d.nutrients === 'object') {
      return { vals: lowerMap(d.nutrients), mode: units || 'unknown' };
    }
    /* flat: the nutrient names sit on the record itself */
    var flat = lowerMap(d);
    var hits = 0;
    LIB.forEach(function (n) {
      n.alt.forEach(function (a) { if (flat[a] !== undefined) hits++; });
    });
    if (hits >= 2) return { vals: flat, mode: units || 'unknown' };
    return null;
  }

  function dietPer1000(d) {
    var b = dietBlock(d);
    return b ? b.vals : null;
  }

  function dietValue(d, key) {
    var b = dietBlock(d);
    if (!b) return null;
    var def = BYKEY[key];
    if (!def) return null;
    var raw = null;
    for (var i = 0; i < def.alt.length; i++) {
      var v = b.vals[def.alt[i]];
      if (v !== undefined && v !== null && v !== '') {
        var n = parseFloat(v);
        if (isFinite(n)) { raw = n; break; }
      }
    }
    if (raw === null) return null;
    if (b.mode === 'per1000') return raw;
    if (b.mode === 'asfed') {
      var E = dietEnergy(d);
      if (!E) return null;
      if (def.unit === 'mg/kg') return perThousandMg(raw, E);
      if (def.out === 'mg') return perThousand(raw, E) * 1000;
      return perThousand(raw, E);
    }
    /* mode unknown: refuse rather than print a figure that might be on the
       wrong basis by a factor of about eight */
    return null;
  }

  function dietCarb(d) {
    var b = dietBlock(d);
    if (!b || b.mode !== 'per1000') return null;
    var v = b.vals.carbohydrate !== undefined ? b.vals.carbohydrate : b.vals.carbs;
    var n = parseFloat(v);
    return isFinite(n) ? n : null;
  }

  /* what the file actually offered, for the message and for the console */
  function dietShape(d) {
    if (!d || typeof d !== 'object') return { keys: [], block: null };
    var b = dietBlock(d);
    return {
      keys: Object.keys(d),
      block: b ? b.mode : null,
      blockKeys: b ? Object.keys(b.vals) : [],
      energy: dietEnergy(d)
    };
  }

  /* A customer gets one plain sentence; the reason goes to the console and to
     wynlcDebug, where whoever is fixing it will actually look. Naming a file or
     a missing key on a storefront page helps nobody standing in a shop. */
  function dietFail(key, detail) {
    state.dietsErrDetail = t(key, detail);
    renderEpoch++;
    state.dietsErr = t('cmp_fail',
      'Wynwood diets are unavailable right now. Everything else still works.');
    if (window.console && console.warn) {
      console.warn('[wynlc] diets: ' + state.dietsErrDetail);
    }
  }

  function loadDiets() {
    var urls = (BOOT.dietUrls || []).filter(Boolean);
    state.dietsTried = urls.slice();
    if (!urls.length) {
      dietFail('cmp_nourl', 'No diet file address was set on this section.');
      drawCompare();
      return;
    }
    var i = 0;
    function next() {
      if (i >= urls.length) {
        dietFail('cmp_fail', 'The Wynwood diet file could not be loaded.');
        drawCompare();
        return;
      }
      var u = urls[i++];
      fetch(u, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)); })
        .then(function (data) {
          var list = pickList(data);
          if (!list || !list.length) { next(); return; }
          state.dietsMeta = (data && data._meta) || (data && data.meta) || null;
          state.dietSample = list[0] || null;
          var usable = list.filter(function (d) { return dietBlock(d); });
          if (!usable.length) {
            var shape = dietShape(list[0]);
            dietFail('cmp_nonutr',
              'The Wynwood diet file loaded but carries no nutrient figures.');
            if (shape.keys.length && window.console && console.warn) {
              console.warn('[wynlc] ' + t('cmp_sawkeys', 'What it does carry:') + ' ' +
                shape.keys.slice(0, 12).join(', ') + '.');
            }
            drawCompare();
            return;
          }
          var unknown = usable.filter(function (d) {
            var b = dietBlock(d);
            return b && b.mode !== 'per1000' && b.mode !== 'asfed';
          });
          if (unknown.length === usable.length) {
            dietFail('cmp_nounits',
              'The Wynwood diet file has nutrient figures but does not say whether they are ' +
              'per 1,000 calories or percentages, so they cannot be compared safely.');
            drawCompare();
            return;
          }
          state.diets = usable;
          state.dietsErr = '';
          renderEpoch++;
          drawCompare();
          render();
        })
        .catch(function () { next(); });
    }
    next();
  }

  function currentDiet() {
    if (!state.diets || !state.pick) return null;
    for (var i = 0; i < state.diets.length; i++) {
      if (String(dietName(state.diets[i])) === state.pick) return state.diets[i];
    }
    return null;
  }

  /* The colours are a dial in the section rather than baked in here, because
     they are brand data and belong where he can edit them. Keyed by handle
     first, then by the normalised name, so a rename in diets.json does not
     silently drop a colour. */
  var DIETCOL = null;
  function dietColours() {
    if (DIETCOL) return DIETCOL;
    DIETCOL = {};
    (BOOT.dietColors || '').split(',').forEach(function (pair) {
      var bits = pair.split('|');
      if (bits.length !== 2) return;
      var k = normKey(bits[0]), v = String(bits[1]).trim().replace(/^#/, '');
      if (k && /^[0-9a-fA-F]{6}$/.test(v)) DIETCOL[k] = '#' + v;
    });
    return DIETCOL;
  }
  function dietColour(d) {
    var m = dietColours();
    return m[normKey(d.handle || '')] || m[normKey(dietName(d))] || null;
  }
  /* The palette has no sanctioned step between a diet colour and cream, so the
     tint ladder from the brand sheet is used: the diet mixed into cream, at the
     30 step, which is the step that stays safe behind text. */
  function tint(hex, amount) {
    var cream = [0xF5, 0xE8, 0xA9];
    var h = String(hex || '').replace('#', '');
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    var out = [0, 1, 2].map(function (i) {
      var ch = parseInt(h.substr(i * 2, 2), 16);
      return Math.round(ch * amount + cream[i] * (1 - amount));
    });
    return '#' + out.map(function (v) {
      return ('0' + v.toString(16)).slice(-2);
    }).join('');
  }

  function isRx(d) {
    return String(d.type || '').toLowerCase().indexOf('rx') > -1;
  }

  /* A dropdown hid fourteen diets behind a tap and looked nothing like the
     coloured pills the rest of the site uses for exactly this list. */
  function drawCompare() {
    var host = $('wynlc-pills'), msg = $('wynlc-cmpmsg'), wrap = $('wynlc-dietwrap');
    if (!host) return;
    if (!state.diets) {
      wrap.hidden = true;
      msg.textContent = state.dietsErr || t('cmp_loading', 'Loading the Wynwood diets.');
      return;
    }
    wrap.hidden = false;
    msg.textContent = '';
    if (host.childNodes.length) { paintPills(); return; }

    state.diets.forEach(function (d) {
      var name = dietName(d);
      var col = dietColour(d);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lc-pill';
      b.setAttribute('data-diet', name);
      b.setAttribute('aria-pressed', 'false');
      if (col) b.style.setProperty('--lc-c', col);
      b.innerHTML = (isRx(d) ? '<span class="lc-pill__rx">' +
        esc(t('cmp_rx', 'Rx')) + '</span>' : '') +
        '<span class="lc-pill__n">' + esc(name) + '</span>';
      b.addEventListener('click', function () {
        /* tapping the chosen one again clears it, so no "none" pill is needed */
        state.pick = (state.pick === name) ? '' : name;
        paintPills();
        render();
        drawSaved();
      });
      host.appendChild(b);
    });
    paintPills();
  }

  function paintPills() {
    var host = $('wynlc-pills');
    if (!host) return;
    Array.prototype.forEach.call(host.querySelectorAll('.lc-pill'), function (b) {
      b.setAttribute('aria-pressed',
        b.getAttribute('data-diet') === state.pick ? 'true' : 'false');
    });
    var clear = $('wynlc-pillclear');
    if (clear) clear.hidden = !state.pick;
  }

  /* ---------------------------------------------------------------------- */
  /* the guarantee is a floor, so the answer is a range                      */
  /* ---------------------------------------------------------------------- */
  /* A guaranteed analysis promises AT LEAST this much protein and fat and AT
     MOST this much fiber and moisture. How far the real food sits from those
     promises is not standardised, so the only honest output is a range, and
     the range differs by format. The margins live in a separate file so they
     can be revised without touching any code.

     Two subtleties drive the whole engine.

     One: the converted figure is a fraction, nutrient over calories, and the
     calorie statement on most labels is itself CALCULATED from the guaranteed
     analysis. So when the real protein runs above its guarantee, the real
     calorie density runs above the stated one too, and the two effects partly
     cancel. Inflating the numerator alone would produce ranges far wider than
     reality. Where the file says a format calculates its calories, the
     denominator is shifted by the same modified Atwater arithmetic the
     manufacturer used, applied as a RATIO to the label figure so the label
     number is never thrown away.

     Two: a nutrient we have no margin data for is not given an invented one.
     It keeps its "at least" bound and only inherits the movement of the
     denominator. */

  var ATW = { protein: 3.5, fat: 8.5, carb: 3.5 };

  function atwater(P, F, NFE) {
    return 10 * (ATW.protein * P + ATW.fat * F + ATW.carb * Math.max(0, NFE));
  }

  function pct3(o) {
    if (!o) return null;
    var out = [o.p10, o.p50, o.p90].map(parseFloat).filter(function (n) { return isFinite(n); });
    return out.length ? out : null;
  }

  /* The file's own labels are headings ("Canned and wet pouches"), which read
     badly dropped into "{n} {f} products". These are the same thing said as an
     adjective. Falls back to the file label if a new format appears. */
  var SHORT_FMT = { kibble: 'dry kibble', canned: 'canned', fresh: 'fresh',
                    raw_frozen: 'frozen raw', dehydrated: 'dehydrated',
                    semi_moist: 'semi-moist' };
  function shortFormat(key, label) {
    return SHORT_FMT[key] || String(label || '').toLowerCase();
  }

  function formatKey() {
    var el = $('wynlc-form');
    return el ? el.value : '';
  }

  function rangeSet() {
    if (!state.ranges || !state.ranges.formats) return null;
    return state.ranges.formats[formatKey()] || null;
  }

  function loadRanges() {
    var urls = (BOOT.rangeUrls || []).filter(Boolean);
    state.rangeTried = urls.slice();
    if (!urls.length) { state.rangesErr = 'no address was set on the section'; drawFormatMsg(); return; }
    var i = 0;
    function next() {
      if (i >= urls.length) {
        state.rangesErr = 'not found at any of: ' + urls.join(', ');
        drawFormatMsg();
        return;
      }
      var u = urls[i++];
      fetch(u, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http')); })
        .then(function (data) {
          if (!data || !data.formats) { next(); return; }
          state.ranges = data;
        renderEpoch++;
          state.rangesErr = '';
          render();
        })
        .catch(function () { next(); });
    }
    next();
  }

  /* Every combination of the percentile edges, so the widest and narrowest
     honest result are found rather than assumed. Five factors at three
     settings is 243 evaluations, which is nothing, and it avoids the trap of
     picking the low end of one factor while forgetting it also lowers the
     denominator. */
  function rangeFor(c, fmt) {
    var rs = fmt ? (state.ranges && state.ranges.formats
      ? state.ranges.formats[fmt] : null) : rangeSet();
    if (!rs) return null;
    var base = {};
    c.rows.forEach(function (r) { base[r.key] = r.asfed; });
    var P = base.protein, F = base.fat;
    if (P === undefined || F === undefined || !(c.E > 0)) return null;
    var FI = base.fiber === undefined ? 0 : base.fiber;
    var M = base.moisture === undefined ? 0 : base.moisture;

    var m = rs.margins || {};
    var mp = pct3(m.protein) || [1, 1, 1];
    var mf = pct3(m.fat) || [1, 1, 1];
    var mfi = pct3(m.fiber) || [1, 1, 1];
    var mm = pct3(m.moisture) || [1, 1, 1];

    /* If the file carries no ash figures for this format, a kibble default is
       not a substitute. Carbohydrate is withheld and the page says why. */
    var ashOpts, ashKnown = true;
    if (base.ash !== undefined) {
      var ma = pct3(rs.ash_when_max_stated) || [1, 1, 1];
      ashOpts = ma.map(function (x) { return base.ash * x; });
    } else {
      var af = pct3(rs.ash_as_fed_pct);
      if (af) { ashOpts = af; }
      else { ashOpts = [0]; ashKnown = false; }
    }

    /* ONLY a calorie statement computed from the GUARANTEE moves when we model
       the real content. If the maker computed it from their TYPICAL values, the
       stated calories already reflect the real protein and fat, so the
       denominator is fixed exactly as it is for a measured statement. Treating
       the two the same would drag the bottom of the range below the bag's own
       arithmetic, which cannot happen, and would contradict the research file's
       own finding that no manufacturer typical value falls below its guarantee. */
    var mode = rs.calorie_statement || 'measured';
    var calc = mode === 'calculated_from_guarantee' || mode === 'mixed';
    /* The baseline energy is recomputed inside the loop with the SAME ash as
       the scenario. The manufacturer worked from the printed protein, fat,
       fiber and moisture plus their own ash, which nobody knows, so letting
       ash differ between the baseline and the scenario would push the
       uncertainty into the ratio in one direction only. */
    function baselineEnergy(ash) {
      return atwater(P, F, 100 - (P + F + FI + M + ash));
    }

    var out = {};
    var overflow = false;
    function note(key, v) {
      if (v === null || !isFinite(v)) return;
      if (!out[key]) out[key] = { lo: v, hi: v };
      else { out[key].lo = Math.min(out[key].lo, v); out[key].hi = Math.max(out[key].hi, v); }
    }

    mp.forEach(function (a) {
      mf.forEach(function (b) {
        mfi.forEach(function (cc) {
          mm.forEach(function (d) {
            ashOpts.forEach(function (ash) {
              var rP = P * a, rF = F * b, rFI = FI * cc, rM = M * d;
              var nfeR = 100 - (rP + rF + rFI + rM + ash);
              var energies = [c.E];
              if (calc) {
                var eG = baselineEnergy(ash);
                if (eG > 0) {
                  var scaled = c.E * (atwater(rP, rF, nfeR) / eG);
                  energies = mode === 'mixed' ? [c.E, scaled] : [scaled];
                }
              }
              /* The margin is applied to the PERCENTAGE, which is where the
                 research measured it. For protein, fat and fiber that is
                 arithmetically the same as scaling the converted figure,
                 because the conversion is a division by a constant. For
                 carbohydrate and for dry matter it is NOT the same, since
                 both are derived from the adjusted percentages rather than
                 converted from them. */
              var dmDiv = 100 - rM;
              function dm(v) { return dmDiv > 0 ? v * 100 / dmDiv : null; }
              note('dm:protein', dm(rP));
              note('dm:fat', dm(rF));
              note('dm:fiber', dm(rFI));
              if (nfeR < 0) overflow = true;
              if (ashKnown) note('dm:carb', dm(Math.max(0, nfeR)));
              /* the adjusted percentages themselves, which the table now shows
                 as the middle step between the label and the converted figure */
              note('pct:protein', rP);
              note('pct:fat', rF);
              note('pct:fiber', rFI);
              note('pct:moisture', rM);
              if (ashKnown) note('pct:carb', Math.max(0, nfeR));
              energies.forEach(function (E) {
                if (!(E > 0)) return;
                note('protein', perThousand(rP, E));
                note('fat', perThousand(rF, E));
                note('fiber', perThousand(rFI, E));
                if (ashKnown) note('carb', perThousand(Math.max(0, nfeR), E));
                /* nutrients with no margin data keep their guarantee and only
                   inherit the denominator moving */
                c.rows.forEach(function (r) {
                  if (['protein', 'fat', 'fiber', 'moisture', 'tcarb'].indexOf(r.key) > -1) return;
                  if (r.def.out === '-') return;
                  var v = r.def.unit === 'mg/kg' ? perThousandMg(r.asfed, E)
                        : r.def.out === 'mg' ? perThousand(r.asfed, E) * 1000
                        : perThousand(r.asfed, E);
                  note(r.key, v);
                });
              });
            });
          });
        });
      });
    });

    /* A printed Total Carbohydrate maximum is better information than anything
       we derive, so it caps the derived range. The food cannot hold more than
       its own printed ceiling. */
    var tcarbMax = null;
    c.rows.forEach(function (r) { if (r.key === 'tcarb') tcarbMax = r.asfed; });
    var tcarbClash = false;
    if (tcarbMax !== null && out.carb && out['pct:carb']) {
      if (out['pct:carb'].lo > tcarbMax + 0.05) {
        /* the derived floor is above the printed ceiling: they contradict, and
           saying so is better than quietly picking one */
        tcarbClash = true;
      } else if (out['pct:carb'].hi > tcarbMax) {
        var ratio = tcarbMax / out['pct:carb'].hi;
        out['pct:carb'].hi = tcarbMax;
        out.carb.hi = out.carb.hi * ratio;
        if (out['dm:carb']) out['dm:carb'].hi = out['dm:carb'].hi * ratio;
      }
    }

    out._meta = {
      tcarbMax: tcarbMax,
      tcarbClash: tcarbClash,
      tcarbCapped: tcarbMax !== null && !tcarbClash,
      format: fmt || formatKey(),
      label: rs.label || formatKey(),
      n: rs.n_products || null,
      confidence: rs.confidence || null,
      caution: rs.caution || null,
      calorie_statement: mode,
      denominatorMoves: calc,
      ranged: { protein: !!m.protein, fat: !!m.fat, fiber: !!m.fiber, carb: ashKnown },
      ashKnown: ashKnown,
      carbOverflow: overflow,
      ashAssumed: base.ash === undefined,
      ashUsed: ashKnown ? ashOpts : []
    };
    return out;
  }

  /* Ranged where we have margin data, a bound where we do not. */
  function isRanged(rng, key) {
    if (!rng || !rng._meta) return false;
    if (key === 'carb') return true;
    return !!rng._meta.ranged[key];
  }

  /* ---------------------------------------------------------------------- */
  /* render                                                                  */
  /* ---------------------------------------------------------------------- */
  function refText(ref, stage) {
    if (!ref) return '&ndash;';
    var r = ref[stage];
    if (!r) return '&ndash;';
    var s = r.min != null ? fig(r.min) + ' ' + t('w_minab', 'min') : '';
    if (r.max != null) s += (s ? ' / ' : '') + fig(r.max) + ' ' + t('w_maxab', 'max');
    return s || '&ndash;';
  }

  function drawFormatMsg() {
    var el = $('wynlc-formmsg');
    if (!el) return;
    /* A file that never loaded used to say NOTHING, which is the worst of the
       three outcomes: the page quietly reverts to bag bounds and looks like it
       is working. It is now the loudest. */
    if (!formatKey()) {
      el.textContent = t('fmt_needed', 'Choose the kind of food and the guarantees below are ' +
        'adjusted for how far that kind usually runs past them.');
      el.hidden = false;
      el.className = 'lc-formmsg lc-formneed';
      return;
    }
    el.className = 'lc-formmsg';
    if (!state.ranges) {
      if (state.rangesErr) {
        el.textContent = t('rng_missing', 'The range data is not loading, so the figures below ' +
          'are the bag’s own bounds rather than ranges.');
        el.hidden = false;
      } else {
        el.hidden = true;
      }
      return;
    }
    var rs = rangeSet();
    if (rs) { el.hidden = true; return; }
    /* The file deliberately omits frozen raw and freeze dried, because
       guarantees in those segments are breached in both directions rather
       than overshot, so a one-sided margin would be actively wrong. Saying
       nothing would leave a person wondering why the ranges vanished. */
    el.textContent = t('fmt_nodata', 'We do not have range data for this kind of food yet, so ' +
      'the figures below are shown as the bag’s own bounds rather than as ranges.');
    el.hidden = false;
  }

  /* The adjustment IS the tool, so its explanation cannot live behind a 15px
     "i" in a table header. It gets a labelled control on the panel and twice
     the words. */
  function drawWhy(rng) {
    var box = $('wynlc-whybox'), btn = $('wynlc-whybtn'), wrap = $('wynlc-why');
    if (!box || !btn || !wrap) return;
    /* The method does not depend on how many fields are filled in, so this
       appears as soon as a kind of food is chosen. Waiting for a full range
       hid the explanation exactly while somebody was still typing. */
    var m = rng && rng._meta ? rng._meta : null;
    if (!m) {
      var rs = rangeSet();
      if (!rs) { wrap.hidden = true; return; }
      m = { format: formatKey(), label: rs.label || formatKey(), n: rs.n_products || null,
            confidence: rs.confidence || null };
    }
    wrap.hidden = false;
    box.innerHTML =
      '<p>' + esc(t('why_1', 'A guaranteed analysis is a promise, not a measurement. It says a ' +
        'bag holds at least this much protein and fat and at most this much fiber and water. ' +
        'The real food is almost always on the other side of those numbers, and the label never ' +
        'says by how far.')) + '</p>' +
      /* THIS DEFAULT ONLY RENDERS IF THE SECTION FAILS TO PUBLISH why_2, which
         should never happen. It said "from state feed control laboratories that
         assay retail bags", which was true of the v1 data and is FALSE of v2 -
         every figure in v2 is a maker's own published typical value.
         A DEFAULT NOBODY EXPECTS TO SEE STILL HAS TO BE TRUE. */
      '<p>' + esc(t('why_2', 'So we went and measured it. We collected products where the maker ' +
        'publishes both the printed guarantee and a typical nutrient value for the same food, ' +
        'and for each one we recorded how far past its own promise it actually ran.')) + '</p>' +
      '<p>' + esc(t('why_3', 'The low and high above are the 10th and 90th of what we found for ' +
        'this kind of food, not the extremes, so one unusual product cannot set the range for ' +
        'everything else. Different kinds of food beat their guarantees by very different ' +
        'amounts, which is why the kind of food has to be chosen before any of this appears.')) +
        '</p>' +
      /* the same short form the note under the table uses, so neither line
         reads "48 Dry kibble products" with a capital mid-sentence */
      '<p class="lc-prov">' + esc(t('adj_why_n', 'Based on {n} {f} products. Confidence: {c}.')
        .replace('{n}', m.n === null || m.n === undefined ? '?' : String(m.n))
        .replace('{f}', shortFormat(m.format, m.label))
        .replace('{c}', m.confidence || '?')) + '</p>';
    btn.textContent = box.hidden
      ? t('why_open', 'How we estimate the range')
      : t('why_close', 'Hide how we estimate it');
  }

  function drawTableAlert(hasRows) {
    var box = $('wynlc-tblalert'), txt = $('wynlc-tblalerttext');
    if (!box || !txt) return;
    /* The prompt under the picker was a long way from the table a person is
       actually reading, so the same message appears on the results too, with
       the control to fix it. */
    if (hasRows && !formatKey()) {
      txt.textContent = t('alert_fmt', 'These figures are the bag numbers alone. Choose the kind ' +
        'of food and they are adjusted for how far that kind usually runs past its guarantees.');
      box.hidden = false;
    } else {
      box.hidden = true;
    }
  }

  /* Bumped whenever something OUTSIDE the form changes what render() would
     draw: the diets arriving, the ranges arriving, a diet being picked. */
  var renderEpoch = 0;
  var lastSig = null;

  function renderSignature() {
    return [renderEpoch, formatKey(), $('wynlc-ecal').value, $('wynlc-eunit').value,
      $('wynlc-ewt') ? $('wynlc-ewt').value : '', $('wynlc-ewtu') ? $('wynlc-ewtu').value : '',
      state.pick || '',
      state.rows.map(function (r) { return r.key + '=' + r.v; }).join(',')].join('|');
  }

  function render() {
    /* A blur fires `change` after the same value already fired `input`, so the
       page used to rebuild itself for nothing. On a phone that rebuild ran
       BETWEEN the mousedown and the mouseup of the tap that caused the blur,
       the layout shifted, and the tap never became a click: pressing Save
       straight after typing did nothing. Redrawing only when something
       actually changed removes the shift, and the wasted work with it. */
    var sig = renderSignature();
    if (sig === lastSig) return;
    lastSig = sig;

    drawFormatMsg();
    var E = kcalPerKg();
    $('wynlc-ewwrap').hidden = !needsWeight();
    $('wynlc-ederived').textContent = E === null ? '' :
      t('e_derived', 'Works out to {n} kcal per kilogram as fed.')
        .replace('{n}', Math.round(E).toLocaleString());
    $('wynlc-ebar').innerHTML = E === null ? '' :
      esc(t('e_bar', 'Energy density')) + ' <b>' + Math.round(E).toLocaleString() + '</b> ' +
      esc(t('e_bar2', 'kcal/kg as fed'));

    var c = computed();
    if ($('wynlc-seemsg') && c && c.rows.length) { $('wynlc-seemsg').hidden = true; }
    var host = $('wynlc-tblhost'), lines = $('wynlc-lines');
    if (!c || !c.rows.length) {
      drawTableAlert(false);
      drawWhy(null);
      host.innerHTML = '<p class="lc-empty">' + esc(t('empty',
        'Enter a calorie content and at least one nutrient.')) + '</p>';
      lines.innerHTML = '';
      lines.hidden = true;
      $('wynlc-basisnote').textContent = '';
      return;
    }

    var ga = true;
    var rng = rangeFor(c);
    drawTableAlert(true);
    var diet = currentDiet();
    var dname = diet ? dietName(diet) : '';

    var carbPrinted = null;
    var dietTint = diet ? tint(dietColour(diet), 0.3) : null;
    var tintAttr = dietTint ? ' style="background:' + dietTint + '"' : '';

    /* Nutrient, what the bag says, what that becomes once the guarantee is
       adjusted, and the converted figure. The AAFCO columns have moved to the
       bars below, and the AAFCO statements were removed entirely. */
    var h = '<div class="lc-tblwrap"><table><thead><tr>' +
      '<th>' + esc(t('th_nutrient', 'Nutrient')) + '</th>' +
      '<th class="lc-c2">' + esc(t('th_asfed', 'Percent of the food')) + '</th>' +
      '<th>' + esc(t('th_adj', 'Minima/maxima adjusted')) + '</th>' +
      '<th>' + esc(t('th_per', 'Per 1,000 cal')) + '</th>' +
      (diet ? '<th class="lc-wyncol"' + tintAttr + '>' + esc(dname) + '</th>' : '') +
      '</tr></thead><tbody>';

    function adjCell(key, unit) {
      var pb = rng && rng['pct:' + key];
      if (!pb) return '<span class="lc-dim">' + esc(t('adj_none', 'not adjusted')) + '</span>';
      if (Math.abs(pb.hi - pb.lo) < 0.005) return figFor(key, pb.lo) + unit;
      return figFor(key, pb.lo) + ' <span class="lc-dim">' + esc(t('w_to', 'to')) + '</span> ' +
        figFor(key, pb.hi) + unit;
    }

    c.rows.forEach(function (r) {
      /* moisture and a printed carbohydrate are inputs, not result rows: the
         first drives the adjustment, the second becomes the ceiling on the
         carbohydrate row further down. */
      if (r.key === 'moisture' || r.key === 'tcarb') return;
      var band = rng && rng[r.key];
      var ranged = band && isRanged(rng, r.key);
      var sym = r.def.bound === 'min' ? '&ge;&nbsp;' : '&le;&nbsp;';
      var unit = r.def.unit === 'mg/kg' ? ' <span class="lc-dim">mg/kg</span>' : '%';
      var val;
      if (r.per1000 === null) {
        val = '<span class="lc-dim">' + esc(t('na', 'not applicable')) + '</span>';
      } else if (ranged) {
        val = '<span class="lc-big">' + figFor(r.key, band.lo) + '</span> <span class="lc-dim">' +
          esc(t('w_to', 'to')) + '</span> <span class="lc-big">' + figFor(r.key, band.hi) +
          '</span> <span class="lc-dim">' + r.outUnit + '</span>';
      } else {
        val = '<span class="lc-bound">' + sym + '</span><span class="lc-big">' +
          figFor(r.key, band ? (r.def.bound === 'min' ? band.lo : band.hi) : r.per1000) +
          '</span> <span class="lc-dim">' + r.outUnit + '</span>';
      }
      /* Figures below the AAFCO minimum used to render red. With the AAFCO
         statements gone that was a colour with nothing to explain it, so it
         went too. */
      var wv = diet ? dietValue(diet, r.key) : null;
      h += '<tr data-n="' + r.key + '"><td>' + esc(nlabel(r.key)) + '</td>' +
        /* the label column echoes what is printed on the label, so it is never
           reformatted: 16 stays 16, 16.5 stays 16.5 */
        '<td class="lc-c2">' + esc(String(r.asfed)) + unit + '</td>' +
        '<td>' + (ranged ? adjCell(r.key, r.def.unit === 'mg/kg' ? '' : '%')
          : '<span class="lc-dim">' + esc(t('adj_none', 'not adjusted')) + '</span>') + '</td>' +
        '<td>' + val + '</td>' +
        (diet ? '<td class="lc-wyncell lc-wyncol"' + tintAttr + '>' + (wv === null
          ? '<span class="lc-dim">&ndash;</span>'
          : figFor(r.key, wv) + ' <span class="lc-dim">' + r.outUnit + '</span>') + '</td>' : '') +
        '</tr>';
    });

    var span = diet ? 4 : 3;
    /* the middle of the format's published ash band, so the printed
       carbohydrate and the adjusted one rest on the same assumption */
    var ashMid = null;
    if (rng && rng._meta && rng._meta.ashKnown && rng._meta.ashUsed.length) {
      var au0 = rng._meta.ashUsed.slice().sort(function (a, b) { return a - b; });
      ashMid = au0[Math.floor(au0.length / 2)];
    }
    var carb = carbohydrate(c, ashMid);
    if (carb && !carb.impossible) { carbPrinted = carb.pct; }
    var noAsh = !!(rng && rng._meta && !rng._meta.ashKnown && !c.rows.some(function (r) {
      return r.key === 'ash';
    }));
    if (rng && rng._meta && rng._meta.tcarbClash) {
      h += '<tr data-n="carb"><td>' + esc(t('carb', 'Carbohydrate (NFE)')) + '</td>' +
        '<td colspan="' + span + '" class="lc-flagged" style="text-align:left;white-space:normal">' +
        esc(t('carb_clash', 'The bag guarantees no more than {n}% carbohydrate, but the other ' +
          'figures on it leave more than that even at their most generous. One of the numbers ' +
          'on this label does not agree with the others, so no carbohydrate figure is shown.')
          .replace('{n}', fig(rng._meta.tcarbMax))) + '</td></tr>';
    } else if (noAsh) {
      h += '<tr><td>' + esc(t('carb', 'Carbohydrate')) + '</td>' +
        '<td colspan="' + span + '" class="lc-dim" style="text-align:left;white-space:normal">' +
        esc(t('carb_noash', 'Cannot be worked out for this kind of food, because we have no ' +
          'figure for its ash. If the bag prints one, add it above and this fills in.')) +
        '</td></tr>';
    } else if (carb && !carb.impossible) {
      var ashNote = '';
      if (rng && rng._meta && rng._meta.ashKnown && rng._meta.ashAssumed &&
          rng._meta.ashUsed.length > 1) {
        var au = rng._meta.ashUsed;
        ashNote = t('carb_ashr', ', ash taken as {a}% to {b}% for this kind of food')
          .replace('{a}', fig(Math.min.apply(null, au))).replace('{b}', fig(Math.max.apply(null, au)));
      } else if (carb.assumedAsh) {
        ashNote = t('carb_ash', ', ash assumed at {n}%').replace('{n}', carb.ash);
      }
      var tcMax = rng && rng._meta ? rng._meta.tcarbMax : null;
      var sub = t('carb_sub', 'whatever is left over') + ashNote;
      if (tcMax !== null && rng._meta.tcarbCapped) {
        sub = t('carb_capped', 'the bag guarantees no more than {n}%, so the top of this range ' +
          'is its own ceiling rather than ours').replace('{n}', figFor('carb', tcMax));
      }
      if (rng && rng._meta && rng._meta.carbOverflow) {
        sub = t('carb_over', 'whatever is left over. At the top of these ranges the figures ' +
          'already add past 100%, so only the upper end can be pinned down.');
      }
      var carbVal;
      if (!rng || !rng.carb) {
        carbVal = '<span class="lc-big">' + figFor('carb', carb.per1000) + '</span> <span class="lc-dim">g</span>';
      } else if (rng._meta.carbOverflow) {
        carbVal = '<span class="lc-dim">' + esc(t('w_upto', 'up to')) + '</span> <span class="lc-big">' +
          figFor('carb', rng.carb.hi) + '</span> <span class="lc-dim">g</span>';
      } else {
        carbVal = '<span class="lc-big">' + figFor('carb', rng.carb.lo) + '</span> <span class="lc-dim">' +
          esc(t('w_to', 'to')) + '</span> <span class="lc-big">' + figFor('carb', rng.carb.hi) +
          '</span> <span class="lc-dim">g</span>';
      }
      var wcarb = diet ? dietCarb(diet) : null;
      h += '<tr class="lc-carbrow" data-n="carb"><td>' + esc(t('carb', 'Carbohydrate')) +
        '<br><span class="lc-sm">' + esc(sub) + '</span></td>' +
        '<td class="lc-c2">' + (tcMax !== null
          ? '<span class="lc-bound">&le;&nbsp;</span>' + figFor('carb', tcMax) + '%'
          : figFor('carb', carb.pct) + '%') + '</td>' +
        '<td>' + (rng && rng['pct:carb']
          ? (rng._meta.carbOverflow
            ? '<span class="lc-dim">' + esc(t('w_upto', 'up to')) + '</span> ' +
              figFor('carb', rng['pct:carb'].hi) + '%'
            : adjCell('carb', '%'))
          : '<span class="lc-dim">' + esc(t('adj_none', 'not adjusted')) + '</span>') + '</td>' +
        '<td>' + carbVal + '</td>' +
        (diet ? '<td class="lc-wyncell lc-wyncol"' + tintAttr + '>' + (wcarb === null
          ? '<span class="lc-dim">&ndash;</span>'
          : figFor('carb', wcarb) + ' <span class="lc-dim">g</span>') + '</td>' : '') +
        '</tr>' +
        '<tr class="lc-subrow"><td colspan="' + (span + 1) + '">' +
          '<span class="lc-sm">' + esc(sub) + '</span></td></tr>';
    } else if (carb && carb.impossible) {
      h += '<tr data-n="carb"><td>' + esc(t('carb', 'Carbohydrate (NFE)')) + '</td>' +
        '<td colspan="' + span + '" class="lc-flagged" style="text-align:left;white-space:normal">' +
        esc(t('carb_impossible',
          'The entered figures already add past 100%, so carbohydrate cannot be calculated.')) +
        '</td></tr>';
    }

    var ca = null, ph = null;
    c.rows.forEach(function (r) {
      if (r.key === 'calcium') ca = r.per1000;
      if (r.key === 'phosphorus') ph = r.per1000;
    });
    if (ca !== null && ph !== null && ph > 0) {
      var ratio = ca / ph, bad = (ratio < 1 || ratio > 2);
      var wca = diet ? dietValue(diet, 'calcium') : null;
      var wph = diet ? dietValue(diet, 'phosphorus') : null;
      h += '<tr><td>' + esc(t('cap', 'Calcium to phosphorus')) + '</td>' +
        '<td class="lc-dim lc-c2">&ndash;</td>' +
        '<td class="lc-dim">&ndash;</td>' +
        '<td' + (bad ? ' class="lc-flagged"' : '') + '><span class="lc-big">' +
          ratio.toFixed(2) + '</span> : 1</td>' +
        (diet ? '<td class="lc-wyncell lc-wyncol"' + tintAttr + '>' +
          (wca !== null && wph ? (wca / wph).toFixed(2) + ' : 1'
            : '<span class="lc-dim">&ndash;</span>') + '</td>' : '') +
        '</tr>';
    }
    h += '</tbody></table></div>';

    /* The figure block goes ABOVE the table, so the answer is readable before
       anyone reads a row. Only nutrients with a real range appear: a bounded
       figure would need a ">=" the big type cannot carry honestly. */
    var figs = [];
    ['protein', 'fat', 'carb', 'fiber'].forEach(function (key) {
      var band = rng && rng[key];
      if (!band || !isRanged(rng, key)) return;
      var over = key === 'carb' && rng._meta && rng._meta.carbOverflow;
      var lbl = key === 'carb' ? t('carb', 'Carbohydrate') : nlabel(key);
      var num = over
        ? esc(t('w_upto', 'up to')) + ' ' + figFor(key, band.hi)
        : figFor(key, band.lo) + '&ndash;' + figFor(key, band.hi);
      figs.push('<div class="lc-fig" data-n="' + key + '">' +
        '<div class="lc-figline"><span class="lc-fign">' + num + '</span>' +
          '<span class="lc-figu">g</span></div>' +
        '<div class="lc-figc">' + esc(lbl) + '</div>' +
        '</div>');
    });
    if (figs.length) {
      h = '<div class="lc-figs" data-n="' + figs.length + '">' + figs.join('') + '</div>' + h;
    }

    host.innerHTML = h;
    drawWhy(rng);

    drawLines(c, diet, dname, rng);
    /* This used to test the message's own first words, so rewording the copy
       stranded it on screen forever. Never branch on prose: the reason it is
       showing is marked on the element. */
    var sm = $('wynlc-savemsg');
    if (sm && !sm.hidden && sm.getAttribute('data-why') === 'incomplete') {
      sm.hidden = true;
      sm.removeAttribute('data-why');
    }
    if ($('wynlc-savedpanel')) { drawSaved(); }
    else if ($('wynlc-cmpwrap') && !$('wynlc-cmpwrap').hidden) { drawCompareTable(); }

    if (rng && rng._meta) {
      var mt = rng._meta;
      $('wynlc-basisnote').innerHTML =
        '<b>' + esc(t('note_rng_h', 'These are ranges, and that is the point.')) + '</b> ' +
        esc(t('note_rng', 'A bag promises at least this much protein and fat and at most this ' +
          'much fiber and water. It never says by how much it beats its own promise, so a single ' +
          'converted number would be a guess dressed up as a fact. These ranges come from what ' +
          'foods of this kind actually test at.')) +
        '<br><br><span class="lc-prov">' +
        esc(t('note_prov', 'Range based on {n} {f} products. Confidence: {c}.')
          .replace('{n}', mt.n === null || mt.n === undefined ? '?' : String(mt.n))
          .replace('{f}', shortFormat(mt.format, mt.label))
          .replace('{c}', mt.confidence || '?')) +
        (String(mt.confidence).toLowerCase() === 'low'
          ? '<br>' + esc(mt.caution || t('note_thin',
              'That is a thin evidence base, so treat these as indicative rather than settled.'))
          : '') +
        '</span>';
    } else {
      $('wynlc-basisnote').innerHTML =
        '<b>' + esc(t('note_ga_h', 'These are bounds, not values.')) + '</b> ' +
        esc(t('note_ga', 'A guaranteed analysis states a floor for protein and fat and a ceiling ' +
          'for fiber and moisture, so the real food sits somewhere above or below every figure in ' +
          'this table.'));
    }
  }


  function drawLines(c, diet, dname, rngIn) {
    var host = $('wynlc-lines');
    var ga = true;
    var rng = rngIn;
    var any = c.rows.some(function (r) { return AAFCO[r.key] && r.per1000 !== null; });
    /* the bars sit on ink now, so an empty container is a black stripe rather
       than nothing at all */
    if (!any) { host.innerHTML = ''; host.hidden = true; return; }
    host.hidden = false;

    var anyRange = !!(rng && rng._meta);
    /* Two different true statements, and which one applies depends on how the
       maker works out the calories. Asserting either one blindly would be
       wrong half the time. */
    var moves = !!(rng && rng._meta && rng._meta.denominatorMoves);
    var h = '<h3>' + esc(t('lines_h', 'Where the food sits')) + '</h3>' +
      '<p class="lc-lh">' + esc(anyRange
        ? (moves
          ? t('lines_rng', 'The bar is where this food most likely sits. The notch on it is what ' +
            'the bag’s own numbers give if you take them at face value. The bar is not centered on ' +
            'the notch because a food that beats its protein promise usually carries more ' +
            'calories than the bag states as well.')
          : t('lines_fixed', 'The bar is where this food most likely sits. It starts at the ' +
            'notch, which is the bag’s own figure. The bar sits above it because a bag ' +
            'promises a floor and the food is normally comfortably clear of it. It runs as far ' +
            'as foods of this kind usually beat that promise.'))
        : t('lines_ga', 'Each figure is drawn as an arrow because that is what a guarantee is. ' +
            'The arrow starts at the number on the bag and runs in the direction the real food is ' +
            'allowed to be.')) + '</p>';

    /* protein, fat and carbohydrate are the three a person actually weighs a
       food on, so carbohydrate gets a scale too even though AAFCO sets no
       figure for it. Its bar simply has no band behind it. */
    var lines = c.rows.filter(function (r) { return AAFCO[r.key] && r.per1000 !== null; })
      .map(function (r) { return { key: r.key, def: r.def, per1000: r.per1000,
                                   outUnit: r.outUnit, ref: AAFCO[r.key] }; });
    var carbRow = rng && rng.carb && !(rng._meta && rng._meta.carbOverflow);
    if (carbRow) {
      var ci = lines.findIndex(function (l) { return l.key === 'fat'; });
      var entry = { key: 'carb', def: { bound: 'min' }, per1000: (rng.carb.lo + rng.carb.hi) / 2,
                    outUnit: 'g', ref: null, isCarb: true };
      if (ci > -1) lines.splice(ci + 1, 0, entry); else lines.push(entry);
    }

    lines.forEach(function (r) {
      var ref = r.ref;
      var mn = ref ? ref.adult.min : null, mx = ref ? ref.adult.max : null;
      var wv = diet ? (r.isCarb ? dietCarb(diet) : dietValue(diet, r.key)) : null;
      var band = rng && rng[r.key];
      var ranged = band && (r.isCarb || isRanged(rng, r.key));
      var top = Math.max(mx != null ? mx : (mn != null ? mn * 2 : 0), r.per1000 * 1.25,
        mn != null ? mn * 1.6 : 0, wv !== null && wv !== undefined ? wv * 1.25 : 0,
        band ? band.hi * 1.2 : 0);
      var pos = function (v) { return Math.max(0, Math.min(100, v / top * 100)); };
      var bandL = mn != null ? pos(mn) : 0, bandR = mn != null ? pos(mx != null ? mx : top) : 0;
      var p = pos(r.per1000);
      var marker;
      if (ranged) {
        var lo = pos(band.lo), hi = pos(band.hi);
        /* No hard edge, and that is not a cosmetic choice. The printed figure
           is a floor in PERCENT, but this scale is per 1,000 calories, and the
           calorie count moves with the protein and fat. A food that beats its
           protein promise usually carries more calories too, so the converted
           figure can sit slightly either side of the printed one. The notch
           marks the printed figure as a reference, not as a boundary. */
        marker = '<div class="lc-span" style="left:' + Math.min(lo, hi) + '%;width:' +
          Math.max(1, Math.abs(hi - lo)) + '%"></div>' +
          '<div class="lc-notch" style="left:' + p + '%"></div>';
      } else if (r.def.bound === 'min') {
        marker = '<div class="lc-arrow lc-up" style="left:' + p + '%;right:0">' +
          '<div class="lc-foot" style="left:0"></div>' +
          '<div class="lc-stem" style="left:2px;right:9px"></div>' +
          '<div class="lc-ahead" style="right:0"></div></div>';
      } else {
        marker = '<div class="lc-arrow lc-down" style="left:0;width:' + p + '%">' +
          '<div class="lc-foot" style="right:0"></div>' +
          '<div class="lc-stem" style="left:9px;right:2px"></div>' +
          '<div class="lc-ahead" style="left:0"></div></div>';
      }
      var wmark = wv === null ? '' :
        '<div class="lc-wynmark" style="left:' + pos(wv) + '%" title="' + esc(dname) + '"></div>';
      var lead = r.def.bound === 'min' ? t('w_atleast', 'at least ') : t('w_atmost', 'at most ');
      var headline = ranged
        ? figFor(r.key, band.lo) + ' ' + esc(t('w_to', 'to')) + ' ' + figFor(r.key, band.hi) +
          ' ' + r.outUnit + ' ' + esc(t('w_per', 'per 1,000 calories'))
        : esc(lead) + figFor(r.key, r.per1000) + ' ' + r.outUnit + ' ' +
          esc(t('w_per', 'per 1,000 calories'));
      var lbl = r.isCarb ? t('carb', 'Carbohydrate (NFE)') : nlabel(r.key);
      h += '<div class="lc-line" data-n="' + (r.isCarb ? 'carb' : r.key) + '">' +
        '<div class="lc-top"><b>' + esc(lbl) + '</b><span>' + headline +
          (wv === null ? '' : ' <span class="lc-dim">&middot; ' + esc(dname) + ' ' +
            figFor(r.key, wv) + '</span>') + '</span></div>' +
        '<div class="lc-track">' +
          '<div class="lc-rail"></div>' +
          /* The AAFCO band used to be drawn behind every bar. It cluttered
             them, so the bar now carries only the food and the diet. */
          /* No axis. The end of the track is padding round the widest thing on
             the row, not a meaningful bound, so labelling it would dress an
             arbitrary number up as a limit. Every figure is in the line above,
             and the bar's job is only to show this food against the diet on
             the same row. */
          marker + wmark +
        '</div></div>';
    });

    /* AAFCO back, in one line rather than on every bar. It states the standard
       and lets the reader do the comparison, which is the part that was worth
       keeping; the per-bar verdicts were the part that was clutter. */
    var refs = [];
    lines.forEach(function (r) {
      if (!r.ref || !r.ref.adult || r.ref.adult.min == null) return;
      if (['protein', 'fat'].indexOf(r.key) === -1) return;
      refs.push({ key: r.key, adult: r.ref.adult.min, growth: r.ref.growth ? r.ref.growth.min : null });
    });
    /* Blanking the copy has to remove the element, not leave an empty
       paragraph sitting under a dotted rule. */
    var aafcoTpl = t('aafco_line', '');
    if (refs.length && String(aafcoTpl).trim()) {
      /* A published standard is quoted, not rounded: figFor would turn the
         13.75 g fat minimum into 14, which is a different number from the one
         AAFCO prints. */
      var std = function (v) { return v % 1 === 0 ? v.toFixed(0) : v.toFixed(1); };
      var parts = refs.map(function (x) {
        return std(x.adult) + ' g ' + nlabel(x.key).toLowerCase();
      });
      var gparts = refs.filter(function (x) { return x.growth != null; })
        .map(function (x) { return std(x.growth); });
      var growthTpl = t('aafco_growth', '');
      h += '<p class="lc-aafco">' +
        esc(String(aafcoTpl).replace('{a}', parts.join(' and '))) +
        (gparts.length && String(growthTpl).trim()
          ? ' ' + esc(String(growthTpl).replace('{g}', gparts.join(' and ') + ' g')) : '') +
        '</p>';
    }

    h += '<div class="lc-key">' +
      '<span><i class="' + (anyRange ? 'lc-kr' : 'lc-ka') + '"></i>' +
        esc(anyRange ? t('key_rng', 'where this food most likely sits, notched at the printed figure')
                     : t('key_ga', 'the label guarantee, open in the direction the food may run')) +
        '</span>' +
      (diet ? '<span><i class="lc-kw"></i>' + esc(dname) + '</span>' : '') +
      '</div>';
    host.innerHTML = h;
  }


  /* ---------------------------------------------------------------------- */
  /* events                                                                  */
  /* ---------------------------------------------------------------------- */
  ['wynlc-ecal', 'wynlc-eunit', 'wynlc-ewt', 'wynlc-ewtu', 'wynlc-form'].forEach(function (id) {
    $(id).addEventListener('input', render);
    $(id).addEventListener('change', render);
  });

  $('wynlc-addbtn').addEventListener('click', function () {
    var k = $('wynlc-addsel').value;
    if (!k || !BYKEY[k]) return;
    state.rows.push({ key: k, v: '' });
    drawRows(); drawAdd(); render();
    var el = $('wynlc-in-' + k);
    if (el) el.focus();
  });

  if ($('wynlc-pillclear')) {
    $('wynlc-pillclear').addEventListener('click', function () {
      state.pick = '';
      renderEpoch++;
      paintPills();
      render();
      drawSaved();
    });
  }

  /* There is no Calculate button because the page recalculates as you type.
     This one does not compute anything, it carries you to the answer, which on
     a phone is a long way below the fold. Without it the page gives no sign it
     did anything at all. */
  $('wynlc-see').addEventListener('click', function () {
    var c = computed();
    var msg = $('wynlc-seemsg');
    if (!c || !c.rows.length) {
      msg.textContent = t('see_need', 'Add the calories and at least one number off the bag first.');
      msg.hidden = false;
      return;
    }
    msg.hidden = true;
    scrollToEl($('wynlc-res'));
  });

  $('wynlc-print').addEventListener('click', function () { window.print(); });

  $('wynlc-reset').addEventListener('click', function () {
    state.rows = [{ key: 'protein', v: '' }, { key: 'fat', v: '' },
                  { key: 'fiber', v: '' }, { key: 'moisture', v: '' }];
    ['wynlc-brand', 'wynlc-prod', 'wynlc-ecal', 'wynlc-ewt'].forEach(function (id) {
      $(id).value = '';
    });
    $('wynlc-eunit').value = 'kg';
    $('wynlc-ewtu').value = 'g';
    fromPhoto = {};
    shots = [];
    drawShots();
    say('');
    if ($('wynlc-savemsg')) { $('wynlc-savemsg').hidden = true; }
    drawRows(); drawAdd(); render();
  });

  /* ---------------------------------------------------------------------- */
  /* saved foods and the comparison                                          */
  /* ---------------------------------------------------------------------- */
  /* These live on the device. There is no login on this page, so there is
     nowhere else to put them, and the panel says so rather than letting
     somebody discover it when they switch phones. Private browsing throws on
     write, so every access is guarded and falls back to memory for the
     session. */

  var KEY = 'wynlc_saved_v1';
  var MAX_SAVED = 8;
  var MAX_FIELD = 60000;
  var savedMem = null;
  var acctState = 'off';

  function loadSaved() {
    if (savedMem) return savedMem;
    var out = { v: 1, list: [] };
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw) {
        var p = JSON.parse(raw);
        if (p && Array.isArray(p.list)) out = { v: 1, list: p.list };
      }
    } catch (e) { out = { v: 1, list: [] }; }
    savedMem = out;
    return out;
  }

  function persist() {
    try { window.localStorage.setItem(KEY, JSON.stringify(savedMem)); return true; }
    catch (e) { return false; }
  }

  /* ---- the account copy ------------------------------------------------
     The device copy is the fast truth and the account is the durable one.
     Raven answers 200 for QUEUED, not written, so nothing here ever waits on a
     read-back or treats a reply as proof. On load the two lists are merged by
     id rather than one overwriting the other, because a person can save on a
     phone and a laptop between syncs and neither copy is wrong.
     Everything degrades: no sign in, no metafield, no rid, or a failed write
     all leave the device copy working exactly as before. */

  function accountList() {
    var raw = BOOT.savedAccount;
    if (!raw) return [];
    try {
      var p = JSON.parse(raw);
      if (p && Array.isArray(p.list)) return p.list;
      if (Array.isArray(p)) return p;
    } catch (e) { return []; }
    return [];
  }

  function canWriteAccount() {
    return !!(BOOT.ravenUrl && BOOT.ravenId && BOOT.ravenMac && BOOT.signedIn);
  }

  function mergeAccount() {
    var d = loadSaved();
    var acct = accountList();
    if (!acct.length) return false;
    var seen = {};
    d.list.forEach(function (f) { if (f && f.id) seen[f.id] = true; });
    var added = 0;
    acct.forEach(function (f) {
      if (!f || !f.id || seen[f.id]) return;
      d.list.push(f);
      seen[f.id] = true;
      added++;
    });
    if (d.list.length > MAX_SAVED) { d.list = d.list.slice(-MAX_SAVED); }
    if (added) persist();
    return added > 0;
  }

  /* Trim from the oldest end until it fits the field rather than letting a
     write fail silently at the far end. */
  function accountPayload() {
    var list = loadSaved().list.slice();
    var body = JSON.stringify({ v: 1, list: list });
    while (body.length > MAX_FIELD && list.length > 1) {
      list.shift();
      body = JSON.stringify({ v: 1, list: list });
    }
    return body;
  }

  function pushAccount() {
    if (!canWriteAccount()) return;
    var payload = { raven_id: BOOT.ravenId, raven_mac: BOOT.ravenMac,
                    value: accountPayload() };
    payload.resource_id = BOOT.ravenRes || '';
    /* An older rid signs with a nil resource_id and needs the email alongside;
       one made in the current Raven UI signs with the customer id and does not.
       Sending the email when it is not wanted is a 422. */
    if (!BOOT.ravenRes && BOOT.customerEmail) { payload.customer_email = BOOT.customerEmail; }
    acctState = 'saving';
    drawAcct();
    fetch(BOOT.ravenUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ raven: payload })
    })
      .then(function (r) { acctState = r.ok ? 'saved' : 'failed'; })
      .catch(function () { acctState = 'failed'; })
      .then(drawAcct);
  }

  function drawAcct() {
    var el = $('wynlc-acct');
    if (!el) return;
    var msg = '';
    if (!BOOT.signedIn) { msg = t('sv_signin', 'Saved on this device. Sign in and they will follow you to your other devices.'); }
    else if (!canWriteAccount()) { msg = t('sv_devonly', 'Saved on this device only.'); }
    else if (acctState === 'saving') { msg = t('sv_syncing', 'Saving to your account.'); }
    else if (acctState === 'failed') { msg = t('sv_syncfail', 'Saved on this device. They could not be added to your account just now, so they may not appear on your other devices.'); }
    else { msg = t('sv_synced', 'Saved to your account, so they will follow you to your other devices.'); }
    el.textContent = msg;
    el.hidden = !msg;
  }

  function foodLabel(f) {
    var n = [f.brand, f.product].filter(Boolean).join(' ').trim();
    return n || t('sv_unnamed', 'Unnamed food');
  }

  /* What gets stored is what was TYPED, plus the energy density, never the
     converted figures. If the arithmetic ever changes, everything already
     saved recomputes correctly instead of being frozen wrong. */
  function snapshot() {
    var c = computed();
    if (!c || !c.rows.length) return null;
    var rows = {};
    c.rows.forEach(function (r) { rows[r.key] = r.asfed; });
    return {
      id: 'f' + Date.now() + Math.floor(Math.random() * 1000),
      brand: ($('wynlc-brand').value || '').trim(),
      product: ($('wynlc-prod').value || '').trim(),
      basis: state.basis,
      format: formatKey(),
      E: c.E,
      rows: rows
    };
  }

  function restore(f) {
    var E = computedFromSaved(f);
    return E;
  }

  function computedFromSaved(f) {
    var moist = (f.rows && f.rows.moisture !== undefined) ? f.rows.moisture : null;
    var out = [];
    Object.keys(f.rows || {}).forEach(function (key) {
      var def = BYKEY[key];
      if (!def) return;
      var v = f.rows[key];
      if (v === null || v === undefined) return;
      var o = { key: key, def: def, asfed: v };
      if (def.unit === 'mg/kg') { o.per1000 = perThousandMg(v, f.E); o.outUnit = 'mg'; }
      else if (def.out === '-') { o.per1000 = null; o.outUnit = null; }
      else if (def.out === 'mg') { o.per1000 = perThousand(v, f.E) * 1000; o.outUnit = 'mg'; }
      else { o.per1000 = perThousand(v, f.E); o.outUnit = 'g'; }
      out.push(o);
    });
    return { E: f.E, moisture: moist, rows: out };
  }

  function sameFood(a, b) {
    if (!a || !b) return false;
    if ((a.format || '') !== (b.format || '')) return false;
    if ((a.brand || '') !== (b.brand || '')) return false;
    if ((a.product || '') !== (b.product || '')) return false;
    if (Math.abs((a.E || 0) - (b.E || 0)) > 0.5) return false;
    var ka = Object.keys(a.rows || {}), kb = Object.keys(b.rows || {});
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) {
      if (Math.abs((a.rows[ka[i]] || 0) - (b.rows[ka[i]] || 0)) > 0.0001) return false;
    }
    return true;
  }

  function saveCurrent() {
    var snap = snapshot();
    var msg = $('wynlc-savemsg');
    if (!snap) {
      msg.textContent = t('sv_need', 'Add calories and at least one nutrient first.');
      msg.setAttribute('data-why', 'incomplete');
      msg.hidden = false;
      return;
    }
    var d = loadSaved();
    if (d.list.some(function (f) { return sameFood(f, snap); })) {
      msg.textContent = t('sv_dupe', 'That food is already saved.');
      msg.removeAttribute('data-why');
      msg.hidden = false;
      return;
    }
    if (d.list.length >= MAX_SAVED) {
      msg.textContent = t('sv_full', 'That is as many as this can hold. Remove one first.')
        .replace('{n}', MAX_SAVED);
      msg.removeAttribute('data-why');
      msg.hidden = false;
      return;
    }
    d.list.push(snap);
    var stored = persist();
    pushAccount();
    msg.textContent = stored
      ? t('sv_done', 'Saved. Press Start over to enter the next one.')
      : t('sv_nostore', 'Saved for now, but this browser will not keep it after you close the tab.');
    msg.removeAttribute('data-why');
    msg.hidden = false;
    drawSaved();
  }

  function loadSavedFood(f) {
    $('wynlc-brand').value = f.brand || '';
    $('wynlc-prod').value = f.product || '';
    if (f.format) { $('wynlc-form').value = f.format; }
    /* what was stored is kcal per kg, so the unit goes back to per kg with it */
    $('wynlc-eunit').value = 'kg';
    $('wynlc-ecal').value = f.E ? Math.round(f.E * 100) / 100 : '';
    var rows = [];
    ['protein', 'fat', 'fiber', 'moisture'].forEach(function (k) {
      rows.push({ key: k, v: (f.rows && f.rows[k] !== undefined) ? String(f.rows[k]) : '' });
    });
    Object.keys(f.rows || {}).forEach(function (k) {
      if (['protein', 'fat', 'fiber', 'moisture'].indexOf(k) > -1) return;
      if (!BYKEY[k]) return;
      rows.push({ key: k, v: String(f.rows[k]) });
    });
    state.rows = rows;
    fromPhoto = {};
    shots = [];
    drawShots();
    say('');
    drawRows(); drawAdd(); render(); drawSaved();
    var top = $('wynlc-res');
    scrollToEl(top);
  }

  function removeSaved(id) {
    var d = loadSaved();
    d.list = d.list.filter(function (f) { return f.id !== id; });
    persist();
    pushAccount();
    drawSaved();
    if (!d.list.length) { $('wynlc-cmpwrap').hidden = true; }
    else if (!$('wynlc-cmpwrap').hidden) { drawCompareTable(); }
  }

  /* A chosen Wynwood diet IS a column, so it has to count toward opening the
     comparison. Counting only foods meant picking a diet did nothing visible
     and you had to find the jump button to see it. */
  function columnCount() {
    var d = loadSaved();
    var cur = snapshot();
    var foods = d.list.length;
    if (cur && !d.list.some(function (f) { return sameFood(f, cur); })) foods++;
    return { foods: foods, total: foods + (currentDiet() ? 1 : 0) };
  }

  /* Once anything is SAVED the comparison stays open. It used to hide itself
     until there were two columns, which meant a button existed purely to
     reveal it, and that button was the thing people had to be told about.
     The food merely on screen does not count: it is already the table above,
     so opening for it alone would just repeat that. */
  function worthComparing() {
    return loadSaved().list.length >= 1;
  }

  function drawSaved() {
    var host = $('wynlc-savedlist');
    if (!host) return;
    var d = loadSaved();
    $('wynlc-savedpanel').hidden = d.list.length === 0;
    /* Two foods is the whole point of saving one, so the comparison opens
       itself rather than hiding behind another button. */
    var w = $('wynlc-cmpwrap');
    if (w && worthComparing() && w.hidden) { w.hidden = false; }
    if (w && !w.hidden) { drawCompareTable(); }
    var hint = $('wynlc-savedhint');
    if (hint) {
      hint.textContent = columnCount().total < 2
        ? t('sv_one', 'One saved. Enter a second food, or pick one of ours below, and they ' +
            'appear side by side.')
        : '';
      hint.hidden = !hint.textContent;
    }
    host.innerHTML = '';
    d.list.forEach(function (f) {
      var chip = document.createElement('div');
      chip.className = 'lc-chip';
      var prot = null;
      if (f.rows && f.rows.protein !== undefined && f.E) {
        prot = perThousand(f.rows.protein, f.E);
      }
      chip.innerHTML = '<button type="button" class="lc-chipload" aria-label="' +
          esc(t('sv_load', 'Show') + ' ' + foodLabel(f)) + '">' +
          '<span class="lc-chipn">' + esc(foodLabel(f)) + '</span>' +
          (prot === null ? '' : '<span class="lc-chipv">' + figFor('protein', prot) + ' ' +
            esc(t('sv_prot', 'g protein')) + '</span>') + '</button>' +
        '<button type="button" class="lc-chipx" aria-label="' + esc(t('sv_remove', 'Remove') +
          ' ' + foodLabel(f)) + '">&times;</button>';
      chip.querySelector('.lc-chipx').addEventListener('click', function () { removeSaved(f.id); });
      /* Tapping a saved food puts it back on the page, so the table and the
         scales above show it as well as the comparison below. Reading a saved
         food only in the side by side was the gap. */
      chip.querySelector('.lc-chipload').addEventListener('click', function () { loadSavedFood(f); });
      host.appendChild(chip);
    });

  }

  /* One column per food. The bound symbol travels with each cell, because two
     foods can be on different bases and a promise beside a measurement is not
     a like for like comparison. The note above the table says so when it
     happens. */
  function drawCompareTable() {
    var d = loadSaved();
    var foods = d.list.slice();
    var cur = snapshot();
    /* A food that has just been saved is still sitting in the form, so adding
       the on-screen entry unconditionally showed the SAME food twice, side by
       side, under the same name. That duplication was most of why this screen
       read as broken. Compare on content, not on id. */
    if (cur && !foods.some(function (f) { return sameFood(f, cur); })) {
      cur.current = true;
      foods.push(cur);
    }
    var host = $('wynlc-cmptbl');
    if (!foods.length) {
      host.innerHTML = '<p class="lc-empty">' + esc(t('sv_none', 'Nothing saved yet.')) + '</p>';
      return;
    }

    var comp = foods.map(computedFromSaved);
    /* Each saved food carries the kind of food it was, so its ranges rebuild
       here exactly as they do in the main table. Without that the comparison
       would show bounds beside ranges, which is the comparison this whole page
       exists to prevent. */
    var rngs = foods.map(function (f, i) {
      return f.format ? rangeFor(comp[i], f.format) : null;
    });
    var keys = [];
    comp.forEach(function (c) {
      c.rows.forEach(function (r) {
        if (r.per1000 !== null && keys.indexOf(r.key) === -1) keys.push(r.key);
      });
    });
    keys.sort(function (a, b) {
      var order = LIB.map(function (n) { return n.key; });
      return order.indexOf(a) - order.indexOf(b);
    });
    /* Carbohydrate is the row most people look for and it was in the main
       table but not here, because it is derived rather than entered. */
    var carbs = comp.map(function (cc, i) {
      var rg = rngs[i];
      var mid = null;
      if (rg && rg._meta && rg._meta.ashKnown && rg._meta.ashUsed.length) {
        var au = rg._meta.ashUsed.slice().sort(function (x, y) { return x - y; });
        mid = au[Math.floor(au.length / 2)];
      }
      var cb = carbohydrate(cc, mid);
      return { plain: cb, band: rg && rg.carb ? rg.carb : null,
               over: !!(rg && rg._meta && rg._meta.carbOverflow) };
    });
    var anyCarb = carbs.some(function (x) { return x.band || (x.plain && !x.plain.impossible); });

    var diet = currentDiet();
    var mixed = foods.some(function (f) { return f.basis === 'ga'; }) &&
                foods.some(function (f) { return f.basis === 'typical'; });

    var h = '';
    if (mixed) {
      h += '<p class="lc-mixed">' + esc(t('sv_mixed', 'Careful. Some of these came off a bag as ' +
        'promises and others are tested numbers, so they are not strictly like for like. The ' +
        'symbols in each cell tell you which is which.')) + '</p>';
    }
    h += '<div class="lc-cmpwrap"><table class="lc-cmptable"><thead><tr><th>' +
      esc(t('th_nutrient', 'Nutrient')) + '</th>';
    foods.forEach(function (f) {
      var fmtLabel = '';
      if (f.format && state.ranges && state.ranges.formats &&
          state.ranges.formats[f.format]) {
        fmtLabel = state.ranges.formats[f.format].label || '';
      }
      h += '<th>' + esc(foodLabel(f)) +
        (fmtLabel ? '<br><span class="lc-cur">' + esc(fmtLabel) + '</span>' : '') +
        (f.current ? '<br><span class="lc-cur">' + esc(t('sv_current', 'on screen now')) +
          '</span>' : '') + '</th>';
    });
    var dTint = diet ? tint(dietColour(diet), 0.3) : null;
    var dAttr = dTint ? ' style="background:' + dTint + '"' : '';
    if (diet) h += '<th class="lc-wyncol"' + dAttr + '>' + esc(dietName(diet)) + '</th>';
    h += '</tr></thead><tbody>';

    /* the calorie density row was removed: every other row is per 1,000
       calories and it was the one figure on a different basis */


    keys.forEach(function (key) {
      var def = BYKEY[key];
      h += '<tr data-n="' + key + '"><td>' + esc(nlabel(key)) + '</td>';
      comp.forEach(function (c, i) {
        var row = null;
        c.rows.forEach(function (r) { if (r.key === key) row = r; });
        if (!row || row.per1000 === null) { h += '<td class="lc-dim">&ndash;</td>'; return; }
        var rg = rngs[i], bd = rg && rg[key];
        if (bd && isRanged(rg, key)) {
          h += '<td><b>' + figFor(key, bd.lo) + '</b> <span class="lc-dim">' +
            esc(t('w_to', 'to')) + '</span> <b>' + figFor(key, bd.hi) + '</b></td>';
          return;
        }
        var sym = def.bound === 'min' ? '&ge;&nbsp;' : '&le;&nbsp;';
        h += '<td><span class="lc-bound">' + sym + '</span><b>' +
          figFor(key, bd ? (def.bound === 'min' ? bd.lo : bd.hi) : row.per1000) + '</b></td>';
      });
      if (diet) {
        var wv = dietValue(diet, key);
        h += '<td class="lc-wyncol"' + dAttr + '>' + (wv === null ? '&ndash;'
          : '<b>' + figFor(key, wv) + '</b> <span class="lc-dim">' +
            (def.unit === 'mg/kg' || def.out === 'mg' ? 'mg' : 'g') + '</span>') + '</td>';
      }
      h += '</tr>';
    });
    if (anyCarb) {
      h += '<tr data-n="carb"><td>' + esc(t('carb', 'Carbohydrate (NFE)')) + '</td>';
      carbs.forEach(function (x) {
        if (x.band && !x.over) {
          h += '<td><b>' + figFor('carb', x.band.lo) + '</b> <span class="lc-dim">' + esc(t('w_to', 'to')) +
            '</span> <b>' + figFor('carb', x.band.hi) + '</b></td>';
        } else if (x.band && x.over) {
          h += '<td><span class="lc-dim">' + esc(t('w_upto', 'up to')) + '</span> <b>' +
            figFor('carb', x.band.hi) + '</b></td>';
        } else if (x.plain && !x.plain.impossible) {
          h += '<td><b>' + figFor('carb', x.plain.per1000) + '</b></td>';
        } else {
          h += '<td class="lc-dim">&ndash;</td>';
        }
      });
      if (diet) {
        var wc = dietCarb(diet);
        h += '<td class="lc-wyncol"' + dAttr + '>' + (wc === null ? '&ndash;'
          : '<b>' + figFor('carb', wc) + '</b> <span class="lc-dim">g</span>') + '</td>';
      }
      h += '</tr>';
    }
    h += '</tbody></table></div>';
    h += '<p class="lc-cmpfoot">' +
      /* the swipe hint is about a screen, so it gets its own wrapper and is
         dropped from the printout */
      (foods.length > 1 ? '<span class="lc-screenonly">' +
        esc(t('sv_swipe', 'Swipe sideways to see all foods.')) + '</span> ' : '') +
      esc(t('sv_unit', 'Every nutrient is shown per 1,000 calories.')) + '</p>';
    host.innerHTML = h;
  }

  function resetForm() {
    state.rows = [{ key: 'protein', v: '' }, { key: 'fat', v: '' },
                  { key: 'fiber', v: '' }, { key: 'moisture', v: '' }];
    ['wynlc-brand', 'wynlc-prod', 'wynlc-ecal', 'wynlc-ewt'].forEach(function (id) {
      $(id).value = '';
    });
    $('wynlc-eunit').value = 'kg';
    $('wynlc-ewtu').value = 'g';
    fromPhoto = {};
    shots = [];
    drawShots();
    say('');
    drawRows(); drawAdd(); render();
  }

  if ($('wynlc-whybtn')) {
    $('wynlc-whybtn').addEventListener('click', function () {
      var box = $('wynlc-whybox'), btn = $('wynlc-whybtn');
      var open = box.hidden;
      box.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? t('why_close', 'Hide how we estimate it')
                             : t('why_open', 'How we estimate the range');
    });
  }

  if ($('wynlc-tblalertbtn')) {
    $('wynlc-tblalertbtn').addEventListener('click', function () {
      var sel = $('wynlc-form');
      if (!sel) return;
      scrollToEl(sel);
      sel.focus();
    });
  }

  if ($('wynlc-save')) {
    mergeAccount();
    drawAcct();
    $('wynlc-save').addEventListener('click', saveCurrent);
    /* Save, then clear, then scroll back to the top of the form, in one tap.
       Asking somebody to press Save and then hunt for Start over is the step
       everyone missed. */
    $('wynlc-next').addEventListener('click', function () {
      var before = loadSaved().list.length;
      saveCurrent();
      if (loadSaved().list.length === before) return;
      resetForm();
      var top = $('wynlc-photo') || $('wynlc-brand');
      scrollToEl(top);
    });
    $('wynlc-clearall').addEventListener('click', function () {
      savedMem = { v: 1, list: [] };
      persist();
      pushAccount();
      drawSaved();
      $('wynlc-cmpwrap').hidden = true;
      $('wynlc-savemsg').hidden = true;
    });
    drawSaved();
  }

  /* ---------------------------------------------------------------------- */
  /* the photo reader                                                        */
  /* ---------------------------------------------------------------------- */
  /* The whole panel only exists if the section supplied a reader address, so
     the page is complete and useful with the feature switched off. */

  var shots = [];

  /* Three ways to turn the file into pixels, tried in order. createImageBitmap
     takes the Blob straight and builds no URL, so it survives a browser or a
     frame that refuses blob: and data: images. This order was arrived at the
     hard way: the single-path version failed on a real phone. */
  function loadImg(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('decode refused')); };
      img.src = url;
    });
  }
  function readAsDataURL(file) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(fr.result); };
      fr.onerror = function () { reject(new Error('unreadable file')); };
      fr.readAsDataURL(file);
    });
  }
  function decode(file) {
    var p = Promise.reject();
    if (window.createImageBitmap) {
      p = p.catch(function () {
        /* imageOrientation MUST be asked for. createImageBitmap ignores the
           EXIF rotation flag by default, so a phone that stores the picture
           sideways hands the reader a sideways label and it fails for that
           person and nobody else. Older browsers ignore the option, which is
           why the img fallback below is still worth keeping: an <img> applies
           EXIF on its own. */
        return createImageBitmap(file, { imageOrientation: 'from-image' })
          .catch(function () { return createImageBitmap(file); })
          .then(function (b) { return { src: b, w: b.width, h: b.height }; });
      });
    }
    p = p.catch(function () {
      return readAsDataURL(file).then(loadImg).then(function (i) {
        return { src: i, w: i.naturalWidth, h: i.naturalHeight };
      });
    });
    p = p.catch(function () {
      var u = URL.createObjectURL(file);
      return loadImg(u).then(function (i) {
        URL.revokeObjectURL(u);
        return { src: i, w: i.naturalWidth, h: i.naturalHeight };
      }).catch(function (e) { URL.revokeObjectURL(u); throw e; });
    });
    return p.catch(function () {
      var heic = /hei[cf]/i.test(file.type || '') || /\.hei[cf]$/i.test(file.name || '');
      var err = new Error(heic ? t('ph_heic', 'That photo is in a format this browser cannot open.')
                               : t('ph_bad', 'This browser could not open that photo.'));
      err.heic = heic;
      throw err;
    });
  }

  var MIN_EDGE = 500;

  function shrink(file) {
    return decode(file).then(function (d) {
      if (Math.max(d.w, d.h) < MIN_EDGE) {
        var e = new Error(t('ph_small', 'That picture is too small to read the small print on a ' +
          'label. Take it with the camera rather than sending a screenshot or a saved thumbnail.'));
        e.small = true;
        throw e;
      }
      var max = 1600;
      var sc = Math.min(1, max / Math.max(d.w, d.h));
      var w = Math.max(1, Math.round(d.w * sc)), h = Math.max(1, Math.round(d.h * sc));
      var cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      cv.getContext('2d').drawImage(d.src, 0, 0, w, h);
      if (d.src.close) d.src.close();
      return { data: cv.toDataURL('image/jpeg', 0.85).split(',')[1], canvas: cv };
    });
  }

  function drawShots() {
    var host = $('wynlc-shots');
    if (!host) return;
    host.innerHTML = '';
    shots.forEach(function (sh, i) {
      var d = document.createElement('div');
      d.className = 'lc-shot';
      d.innerHTML = '<button type="button" aria-label="' +
        esc(t('ph_remove', 'Remove photo')) + ' ' + (i + 1) + '">&times;</button>';
      sh.canvas.setAttribute('role', 'img');
      sh.canvas.setAttribute('aria-label', t('ph_photo', 'photo') + ' ' + (i + 1));
      d.insertBefore(sh.canvas, d.firstChild);
      d.querySelector('button').addEventListener('click', function () {
        shots.splice(i, 1); drawShots();
      });
      host.appendChild(d);
    });
    $('wynlc-read').hidden = shots.length === 0;
    $('wynlc-take').textContent = shots.length
      ? t('ph_more', 'Add another photo') : t('ph_take', 'Take a photo');
  }

  /* He asked for this by name: when it fails, say what specifically failed.
     Everything in here is factual and copyable, so a report from a shop floor
     is diagnosable instead of being "it didn't work". */
  function why(info) {
    var bits = [];
    if (info.step) bits.push(t('why_step', 'Failed at') + ': ' + info.step);
    if (info.status) bits.push(t('why_status', 'Server said') + ': ' + info.status);
    if (info.code) bits.push(t('why_code', 'Reason') + ': ' + info.code);
    if (info.file) bits.push(t('why_file', 'File') + ': ' + info.file);
    bits.push(t('why_page', 'This page') + ': ' + location.origin);
    bits.push(t('why_browser', 'Browser') + ': ' + navigator.userAgent);
    return '<span class="lc-whyphoto">' + esc(bits.join('\n')) + '</span>';
  }

  function say(html, kind) {
    var el = $('wynlc-phmsg');
    if (!el) return;
    el.className = 'lc-phmsg' + (kind ? ' lc-' + kind : '');
    el.innerHTML = html;
    el.hidden = !html;
  }

  /* ---- matching what the label calls a row to a row on this page -------- */
  var SYN = {
    protein: ['crudeprotein', 'protein'],
    fat: ['crudefat', 'fat', 'etherextract'],
    /* BOTH spellings, because this list matches what a BAG prints, not what
       this page writes. An imported or Canadian bag really does say Crude
       Fibre. A blanket spelling sweep collapsed these into duplicates once
       already, which silently stopped matching those bags. */
    fiber: ['crudefiber', 'crudefibre', 'fiber', 'fibre'],
    moisture: ['moisture', 'water'],
    ash: ['crudeash', 'ash'],
    tcarb: ['totalcarbohydrate', 'totalcarbohydrates', 'carbohydrate', 'carbohydrates', 'carbs'],
    calcium: ['calcium', 'ca'],
    phosphorus: ['phosphorus', 'phosphorous'],
    sodium: ['sodium'],
    potassium: ['potassium'],
    magnesium: ['magnesium'],
    chloride: ['chloride'],
    linoleic: ['linoleicacid', 'linoleic'],
    epadha: ['epadha', 'epaanddha', 'eicosapentaenoic', 'docosahexaenoic'],
    omega3: ['omega3fattyacids', 'totalomega3', 'omega3'],
    taurine: ['taurine'],
    carnitine: ['lcarnitine', 'carnitine'],
    glucos: ['glucosamine'],
    chondro: ['chondroitin']
  };
  var SYN_ORDER = ['protein', 'fat', 'fiber', 'moisture', 'ash', 'tcarb', 'calcium', 'phosphorus',
    'sodium', 'potassium', 'magnesium', 'chloride', 'linoleic', 'epadha', 'omega3',
    'taurine', 'carnitine', 'glucos', 'chondro'];

  function normName(s) {
    return String(s || '').replace(/\([^)]*\)/g, ' ').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  function matchNutrient(name) {
    var n = normName(name);
    if (!n) return null;
    var i, j;
    for (i = 0; i < SYN_ORDER.length; i++) {
      var list = SYN[SYN_ORDER[i]];
      for (j = 0; j < list.length; j++) { if (n === list[j]) return SYN_ORDER[i]; }
    }
    /* The loose pass takes the LONGEST synonym that appears, not the first one
       found. Order alone gets this wrong: "Glucosamine Hydrochloride" contains
       "chloride", so a first-match rule files a joint supplement under the
       chloride row. Longest wins puts it back under glucosamine. */
    var best = null, bestLen = 0;
    for (i = 0; i < SYN_ORDER.length; i++) {
      var l2 = SYN[SYN_ORDER[i]];
      for (j = 0; j < l2.length; j++) {
        if (l2[j].length > 3 && n.indexOf(l2[j]) > -1 && l2[j].length > bestLen) {
          best = SYN_ORDER[i];
          bestLen = l2[j].length;
        }
      }
    }
    return best;
  }

  var PER_MAP = { kg: 'kg', '100g': '100g', oz: 'oz', cup: 'cup', can: 'can', package: 'pkg' };

  function ensureRow(key) {
    for (var i = 0; i < state.rows.length; i++) { if (state.rows[i].key === key) return i; }
    state.rows.push({ key: key, v: '' });
    return state.rows.length - 1;
  }

  /* Nothing here is accepted quietly. Every field it fills is marked, and the
     page says plainly which rows it could not use. */
  function applyResult(r) {
    var filled = 0, unused = [], blank = [];

    if (r.brand) { $('wynlc-brand').value = r.brand; filled++; }
    if (r.product) { $('wynlc-prod').value = r.product; filled++; }

    var cal = r.calories || {};
    if (cal.value !== null && cal.value !== undefined && PER_MAP[cal.per]) {
      $('wynlc-ecal').value = cal.value;
      $('wynlc-eunit').value = PER_MAP[cal.per];
      filled++;
      if (['cup', 'can', 'pkg'].indexOf(PER_MAP[cal.per]) > -1) {
        if (cal.unit_weight) {
          $('wynlc-ewt').value = cal.unit_weight;
          if (['g', 'oz', 'lb'].indexOf(cal.unit_weight_units) > -1) {
            $('wynlc-ewtu').value = cal.unit_weight_units;
          }
        } else {
          blank.push(t('ph_needweight', 'the weight of one ' + (cal.per || 'serving')));
        }
      }
    } else {
      blank.push(t('ph_needcal', 'the calorie statement'));
    }

    fromPhoto = {};
    var rows = Array.isArray(r.nutrients) ? r.nutrients : [];
    rows.forEach(function (n) {
      var key = matchNutrient(n.name);
      if (!key) { if (n.name) unused.push(n.name); return; }
      var def = BYKEY[key];
      var val = null;
      if (def.unit === 'mg/kg') {
        val = (n.mg_per_kg !== null && n.mg_per_kg !== undefined) ? n.mg_per_kg : null;
      } else {
        val = (n.percent !== null && n.percent !== undefined) ? n.percent : null;
      }
      if (val === null) { blank.push(n.name); return; }
      var i = ensureRow(key);
      state.rows[i].v = String(val);
      fromPhoto[key] = true;
      filled++;
    });

    (Array.isArray(r.unreadable) ? r.unreadable : []).forEach(function (u) {
      if (u && blank.indexOf(u) === -1) blank.push(u);
    });

    drawRows(); drawAdd(); render();

    if (!filled) {
      var h0 = '<b>' + esc(t('ph_nothing', 'It could not read anything usable from that photo.')) +
        '</b><br><br>' + esc(t('ph_nothingfix', 'Get closer so the panel fills the frame, hold ' +
        'the bag flat, and keep the flash off the shiny parts. Or type the numbers in below.'));
      if (r && r.notes) {
        h0 += '<br><br><b>' + esc(t('ph_itsaid', 'It said')) + ':</b> ' + esc(r.notes);
      }
      if (Array.isArray(r && r.unreadable) && r.unreadable.length) {
        h0 += '<br><br><b>' + esc(t('ph_notread', 'It could not read:')) + '</b> ' +
          esc(r.unreadable.join(', ')) + '.';
      }
      say(h0 + why({ step: 'reading the photo', code: 'nothing legible' }), 'err');
      return;
    }

    var h = '<b>' + esc(t('ph_check', 'Check these against the bag before you trust them.')) +
      '</b> ' + esc(t('ph_checkwhy', 'A photo can misread a decimal point, and the marked boxes ' +
      'below are what it filled in.'));
    if (blank.length) {
      h += '<br><br><b>' + esc(t('ph_notread', 'It could not read:')) + '</b> ' +
        esc(blank.join(', ')) + '.';
    }
    if (unused.length) {
      h += '<br><br><b>' + esc(t('ph_notused', 'On the bag but not used here:')) + '</b> ' +
        esc(unused.join(', ')) + '.';
    }
    h += '<br><br><button type="button" id="wynlc-confirm" class="lc-confirm">' +
      esc(t('ph_confirm', 'I have checked them')) + '</button>';
    say(h, 'ok');
    var cb = $('wynlc-confirm');
    if (cb) {
      cb.addEventListener('click', function () {
        fromPhoto = {};
        drawRows();
        say('');
      });
    }
  }

  function readPhotos() {
    var url = (BOOT.readerUrl || '').replace(/\/+$/, '');
    if (!url || !shots.length) return;
    $('wynlc-read').disabled = true;
    say(esc(t('ph_reading', 'Reading your photo. This takes a few seconds.')), 'wait');

    /* Without a deadline a slow connection leaves the button dead and the
       message stuck on "Reading" forever. */
    var ctrl = window.AbortController ? new AbortController() : null;
    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      if (ctrl) ctrl.abort();
    }, 45000);

    fetch(url + '/read', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ images: shots.map(function (sh) { return sh.data; }) }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (res) {
        return res.json().then(function (b) { return { ok: res.ok, status: res.status, body: b }; },
          function () { return { ok: false, status: res.status, body: null }; });
      })
      .then(function (out) {
        if (!out.ok || !out.body || out.body.ok !== true || !out.body.result) {
          var b = out.body || {};
          var m = b.error || t('ph_fail', 'The reader could not be reached.');
          var extra = '';
          if (b.code === 'origin') {
            extra = t('ph_origin', 'This usually means the page was opened on a preview or ' +
              'staging address rather than the live shop.');
          } else if (b.code === 'toobig') {
            extra = t('ph_toobig', 'Try one photo at a time.');
          } else if (b.code === 'limited') {
            extra = t('ph_limited', 'Typing the numbers in below still works.');
          } else if (b.code === 'unparsed' || b.code === 'upstream' || b.code === 'busy') {
            extra = t('ph_retry', 'Tap Read the bag again. If it keeps happening, type the ' +
              'numbers in below.');
          }
          say('<b>' + esc(m) + '</b>' + (extra ? '<br><br>' + esc(extra) : '') +
            why({ step: 'sending the photo', status: out.status || 'no reply',
                  code: b.code || '' }), 'err');
          return;
        }
        applyResult(out.body.result);
      })
      .catch(function () {
        if (timedOut) {
          say('<b>' + esc(t('ph_slow', 'That took too long and was stopped.')) + '</b><br><br>' +
            esc(t('ph_slowfix', 'The connection here may be slow. Try one photo instead of two, ' +
              'or move somewhere with better signal.')) +
            why({ step: 'sending the photo', code: 'timeout' }), 'err');
        } else {
          say('<b>' + esc(t('ph_fail', 'The reader could not be reached.')) + '</b><br><br>' +
            esc(t('ph_failfix', 'Check the connection and try again. Typing the numbers in ' +
              'below always works.')) +
            why({ step: 'sending the photo', code: 'no connection' }), 'err');
        }
      })
      .then(function () {
        clearTimeout(timer);
        $('wynlc-read').disabled = false;
      });
  }

  if ($('wynlc-photo')) {
    $('wynlc-take').addEventListener('click', function () { $('wynlc-pick').click(); });
    $('wynlc-pick').addEventListener('change', function (e) {
      var files = Array.prototype.slice.call(e.target.files || []);
      e.target.value = '';
      if (!files.length) return;
      /* settled, not all: one unreadable file used to discard every photo in
         the batch including the good ones */
      Promise.all(files.map(function (f) {
        return shrink(f).then(function (r) { return { ok: true, r: r }; },
                              function (e) { return { ok: false, e: e, name: f.name || '' }; });
      })).then(function (list) {
        var good = list.filter(function (x) { return x.ok; }).map(function (x) { return x.r; });
        var bad = list.filter(function (x) { return !x.ok; });
        if (good.length) { shots = shots.concat(good).slice(0, 4); }
        drawShots();
        if (!bad.length) { say(''); return; }
        var err = bad[0].e;
        var h = '<b>' + esc(err.message) + '</b>';
        if (err.heic) {
          h += '<br><br>' + esc(t('ph_heicfix', 'Use the camera button and take the photo now, ' +
            'rather than choosing one from your library. Or set iPhone Settings, Camera, ' +
            'Formats to Most Compatible.'));
        }
        if (good.length) {
          h += '<br><br>' + esc(t('ph_somekept', 'The other photo was fine and has been kept.'));
        }
        h += why({ step: 'opening the photo', file: bad[0].name });
        say(h, 'err');
      });
    });
    $('wynlc-read').addEventListener('click', readPhotos);
    drawShots();
  }

  /* ---------------------------------------------------------------------- */
  /* boot                                                                    */
  /* ---------------------------------------------------------------------- */
  drawRows();
  drawAdd();
  drawCompare();
  render();
  loadDiets();
  loadRanges();

  /* One console line reports what the diet loader actually saw. Use this
     before assuming the compare panel is broken. */
  window.wynlcDebug = {
    dietsError: function () {
      return { shown: state.dietsErr, why: state.dietsErrDetail || '' };
    },
    diets: function () {
      var sample = state.dietSample || (state.diets ? state.diets[0] : null);
      var shape = dietShape(sample);
      return {
        tried: state.dietsTried,
        loaded: state.diets ? state.diets.length : 0,
        error: state.dietsErr,
        meta: state.dietsMeta,
        /* the sample is kept even when the file was unusable, which is the
           only time anyone runs this */
        sampleName: sample ? dietName(sample) : null,
        sampleKeys: shape.keys,
        nutrientBlock: shape.block,
        nutrientKeys: shape.blockKeys,
        kcalPerKg: shape.energy,
        sample: sample
      };
    },
    state: function () { return state; },
    convert: function (pct, kcalkg) { return perThousand(pct, kcalkg); },
    aafco: AAFCO,
    /* first thing to run if the ranges look wrong: says whether the file
       loaded, which format is selected, and the exact block being applied */
    ranges: function () {
      return { loaded: !!state.ranges, error: state.rangesErr, format: formatKey(),
               /* every address it tried, so a 404 can be read off rather than
                  guessed at */
               tried: state.rangeTried || [],
               set: rangeSet(), meta: state.ranges ? state.ranges._meta : null,
               formats: state.ranges && state.ranges.formats
                 ? Object.keys(state.ranges.formats) : [] };
    },
    _internal: {
      perThousand: perThousand, perThousandMg: perThousandMg, dryMatter: dryMatter,
      carbohydrate: carbohydrate, computed: computed, kcalPerKg: kcalPerKg,
      dietValue: dietValue, pickList: pickList, state: state,
      matchNutrient: matchNutrient, applyResult: applyResult, shots: function () { return shots; },
      rangeFor: rangeFor, rangeSet: rangeSet, atwater: atwater, render: render,
      dietColour: dietColour, isRx: isRx, paintPills: paintPills,
      saved: loadSaved, snapshot: snapshot, computedFromSaved: computedFromSaved,
      account: function () {
        return { signedIn: !!BOOT.signedIn, canWrite: canWriteAccount(), state: acctState,
                 fromAccount: accountList().length, ravenId: BOOT.ravenId || null,
                 ravenMac: BOOT.ravenMac ? 'present' : null, ravenRes: BOOT.ravenRes || null,
                 payloadBytes: accountPayload().length };
      },
      fromPhoto: function () { return fromPhoto; }
    }
  };
})();